var XPortal = XPortal || {};
XPortal.GridActions = (function () {
    var self = {
        ajaxGetResponse: true,
        actionmodels: [],
        updateActionStates: function (kgrid) {
            var model = XPortal.GridActions.actionmodels[kgrid.options.pageData.nodeId];
            if (model != null) {
                SetSessionFilters(kgrid.options.pageData.nodeId, kgrid);
                model.set("norecords", kgrid.dataSource.data().length === 0);
                model.set("islistview", kgrid.dataSource.isListView);
                model.set("inlinedisabledorislistview", model.get("inlinedisabled") || model.get("islistview"));
                model.set("noeditablecolumnsorislistview", model.get("noeditablecolumns") || model.get("islistview"));
                model.set("updatedAt", new Date());
            }
        },
        emptyValueText: "(empty)",
        actions: ["day", "week", "month", "year"],
        ChangeContentView: function (grid, button, selitems) {
            var ginfo = XPortal.Grid.GetGridInfo(grid);
            var cvkey = button.attr("data-cvkey");
            var cpage = ginfo.kgrid ? ginfo.kgrid.dataSource.page() : 0;
            saveGridSelection(ginfo);
            if (ginfo.kgrid && isActionContentViewVisible(ginfo, button)) {
                XPortal.Loader.show({ selector: ginfo.parent, showDelayTime: 0});
                kendo.destroy(ginfo.list);
                ginfo.list.html("");
                const templateKey = "ltemplate" + cvkey.split("-").pop();
                var tmplt = ginfo.kgrid.options[templateKey] || (ginfo.kgrid.options[templateKey] = ensureGroupTemplate(ginfo, kendo.template($("#" + cvkey).html())));
                var pgbl = $.extend({ numeric: false }, ginfo.kgrid.options.pageable);

                ginfo.list.kendoListView({
                    bordered: false, template: tmplt, pageable: pgbl, dataSource: ginfo.kgrid.dataSource, 
                    dataBound: function () {
                        restoreGridSelection(ginfo);
                        initListViewTooltip(ginfo);
                    }, 
                    scrollable: ginfo.kgrid.options.scrollable && ginfo.kgrid.options.scrollable.endless ? "endless" : false,
                });
                ginfo.list.find(".k-listview-content").addClass("row");
                ginfo.list.find(".k-listview-pager").addClass("k-grid-pager");
            }
            else {
                if (ginfo.kgrid) {
                    self.updateActionStates(ginfo.kgrid);
                    XPortal.Notificator.MarkAssignedNotifications(ginfo);
                    ginfo.kgrid.refresh();
                    // if (ginfo.kgrid.options.scrollable) ginfo.kgrid.setOptions({ scrollable: ginfo.kgrid.options.scrollable });
                    // if (ginfo.kgrid.options.pageable) ginfo.kgrid.setOptions({ pageable: ginfo.kgrid.options.pageable });
                }
            }
            if (ginfo.kgrid.dataSource.page() != cpage) ginfo.kgrid.dataSource.page(cpage);
        },
        ReactiveContentView: function (ginfo) {
            var ginfo = XPortal.Grid.GetGridInfo(ginfo.grid, ginfo);
            if (ginfo.list == null || ginfo.klist == null) return;
            var btn = getContentViewAction(ginfo, ginfo.list.attr("data-cvkey"));
            if (!btn) return;
            let ix = 0;
            XPortal.Utils.waitFor(function () {
                if (ix++ > 1000) return true;
                if (!ginfo.kgrid || !ginfo.kgrid.dataSource || ginfo.kgrid.dataSource._requestInProgress) return false;
                ginfo.list.attr("data-cvkey", "");
                setTimeout(function () {
                    self.ChangeContentView(ginfo.grid, btn);
                }, 1);
                return true;
            }, XPortal.Utils.waitFor, 100);
        },
        InitFirstContentView: function (ginfo) {
            let btn = null;
            if (ginfo.grid.hasClass("show-first-view")) {
                btn = getFirstContentViewAction(ginfo, true);
                addRemoveCssTo(ginfo.grid, ginfo.list, "entity-grid-hidden");
            } else {
                btn = getFirstContentViewAction(ginfo, false);
                if (btn && btn.attr("data-cvkey") != "b2grid") btn = null;
            }
            if (!btn) return;
            
            let ix = 0;
            XPortal.Utils.waitFor(function () {
                if (ix++ > 1000) return true;
                if (!ginfo.kgrid) ginfo = XPortal.Grid.GetGridInfo(ginfo.grid);
                if (!ginfo.kgrid || !ginfo.kgrid.dataSource || ginfo.kgrid.dataSource._requestInProgress) return false;
                setTimeout(function () {
                    self.ChangeContentView(ginfo.grid, btn);
                }, 1);
                return true;
            }, XPortal.Utils.waitFor, 100, 50);
        },
        ScrollToError: function ($grid) {
            var scrollContentOffset = $grid.find("tbody").offset().top;
            var selectContentOffset = $grid.find('.navigate-to-error').first().closest("tr").offset().top;
            var distance = selectContentOffset - scrollContentOffset;

            $grid.find(".k-grid-content").animate({
                scrollTop: distance
            }, 400);
        },
        GetWarningMsg: function ($container, key) {
            if (typeof key === "undefined") key = "data-noactiverecords";
            if ($container.length !== 0)
                return $($container[0]).attr(key);
        },
        SubscribeButtons: function (modelName, grid) {
            var isDetailButtons = grid.hasClass('detail-page');
            var $lblSave = isDetailButtons ?  grid.find('.edit-btns-wrapper .lbl-save-state'): grid.find(".lbl-save-state");
            var $btnSave = grid.find("[data-action=SaveDetail]");
            if (!$lblSave.length) return;

            XPortal.Store.AppStore.subscribe(() => {
                var model = XPortal.Store.GetModelByName(modelName);
                var editable = (model && model.GridModel) ? model.GridModel.options.editable : true;

                if (editable && $lblSave.first().hasClass("d-none")) {
                    $btnSave.removeClass("inactive");
                    $lblSave.removeClass("d-none");
                    XPortal.GridActions.showSavedTextPopup($lblSave);
                }
                else if (!editable) {
                    $btnSave.addClass("inactive");
                    $lblSave.addClass("d-none");
                }

                var message = $lblSave.attr("data-nochanges");
                if (model && model.EntityState && model.EntityState.Key) {
                    message = $lblSave.attr("data-" + model.EntityState.Key);
                    if (model.EntityState.Key === "savenumber") {
                        message = message.replace("{count}", model.EntityState.Data.ItemsToSave);
                    }
                }

                if ($lblSave.html() !== message) {
                    $lblSave.html(message);
                    XPortal.GridActions.showSavedTextPopup($lblSave);
                }
                // hide no changes status #1232
                if (message === $lblSave.attr("data-nochanges")) {
                    $lblSave.addClass("d-none"); 
                } else {
                    $lblSave.removeClass("d-none"); 
                }
            });
        },
        showSavedTextPopup: function ($lblSave) {
            var $lblSaveWrapper = $lblSave.closest('.dropdown-item');
            $lblSaveWrapper.addClass('hover');
            setTimeout(function () {
                $lblSaveWrapper.removeClass('hover');
            }, 3000);
        },
        InitActions: function (gridInfo, gridsettings) {
            const grid = gridInfo.grid;
            const kgrid = gridInfo.kgrid;
            const gmodel = XPortal.Store.GetModelByName(gridInfo.modelName);
            var filtered = kgrid.dataSource.filter() && kgrid.dataSource.filter().filters.length > 0;
            var filters = kgrid.dataSource.filter() ? kgrid.dataSource.filter() : [];
            if (gridInfo.parent) {
                kgrid.bind("dataBound", dataSource_change);
                kgrid.bind("columnReorder", updateActionStates);
                kgrid.bind("sort", updateActionStates);
                kgrid.bind("columnHide", updateActionStates);
                kgrid.bind("columnReorder", updateActionStates);
                kgrid.bind("columnResize", updateActionStates);
                kgrid.bind("columnShow", updateActionStates);
                kgrid.bind("detailCollapse", updateActionStates);
                kgrid.bind("detailExpand", updateActionStates);
                //kgrid.bind("detailInit", updateActionStates);
                kgrid.bind("filter", updateActionStates);
                kgrid.bind("group", updateActionStates);
                kgrid.bind("groupCollapse", updateActionStates);
                kgrid.bind("groupExpand", updateActionStates);
                kgrid.bind("navigate", updateActionStates);
                kgrid.bind("page", updateActionStates);
                gmodel.model.autoSaverTimeOut = XPortal.EditActions.GetAutoSaveTimeout(gridsettings);
                self.actionmodels[gridsettings.pageData.nodeId] = new kendo.observable({
                    inlinedisabled: !gridsettings.editable,
                    filtered: filtered,
                    filterOpen: false,
                    norecords: true,
                    noeditablecolumns: !(gridsettings.columns.some(function (value) { return value.canedit || value.cancreate; }) == true),
                    filterActOpts: { filterApplied: filtered },
                    selectActOpts: { allSelected: false },
                    autoSaverTimeOut: gmodel.model.autoSaverTimeOut,
                    collapsedOptions: { collapsed: false },
                    filters: filters,
                    updatedAt: new Date()
                });
                var rebindGridActionModel = function (tb) {
                    try {
                        var tmodel = self.actionmodels[gridsettings.pageData.nodeId];
                        if (tmodel.filters && tmodel.filters.Initialized == null) tmodel.filters.Initialized = false;
                        kendo.bind(tb, tmodel);
                    } catch (e) {
                        console.error("grid settings error", e);
                    }
                };
                _.each(gridInfo.parent.find(".toolbar, .service-toolbar"), rebindGridActionModel);
                self.actionmodels[gridsettings.pageData.nodeId].bind("change", function (e) {
                    _.each(gridInfo.parent.find(".service-toolbar"), rebindGridActionModel);
                });
                //subscription for save button
                self.SubscribeButtons(gridInfo.modelName, gridInfo.parent);
                gridInfo.parent.on("click", ".toolbar .action:not(.action-no-process), .dropdown-menu-in-table .action:not(.action-no-process), .service-toolbar .action:not(.action-no-process)", function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    let el = $(this);
                    let where = el.is(".toolbar .action") ? "headcol" : el.is(".dropdown-menu-in-table .action") ? "row" : "headtoolbar";
                    var activerow = self.GetCurSelectedRow(gridInfo, el);
                    if (where != "row" || !activerow || !activerow.length) activerow = self.GetActiveRows(gridInfo, where == "row");
                    var btn = XPortal.Grid.GetGridOptionButton(gridInfo, el);
                    self.ProcessActionToolbar(grid, el.attr("data-action"), btn, activerow, where);
                });

                gridInfo.parent.on("click", ".k-link", function (e) {
                    var action = $(this).attr("data-name");
                    if (action) {//only for calendar mode
                        e.preventDefault();
                        if (self.actions.includes(action)) {
                            gridInfo.grid.find(".k-link").each(function () { $(this).removeClass("k-state-selected"); });
                            $(this).addClass("k-state-selected");
                        }
                        if (action != "current")
                            XPortal.GridCalendar.RefreshGrid(grid, $(this));
                    }
                });
                gridInfo.parent.on("click", ".entity-cvitem", function (e) {
                    const $targetEl = $(e.target);
                    if ($targetEl.is("a")) return;
                    e.preventDefault();
                    var selCommand = gridInfo.kgrid.options.commandsIndividual ? gridInfo.kgrid.options.commandsIndividual.find(xc => xc.commandName == "select") : null;
                    var activerow = self.GetCurSelectedRow(gridInfo, $(this), null, true);
                    if (selCommand && $targetEl.is("span.checkbox__mark")) {
                        var optionsButton = XPortal.Grid.GetGridOptionButton(gridInfo, $(this), selCommand.action || selCommand.actionAttr);
                        self.ProcessActionToolbar(gridInfo.grid, selCommand.action || selCommand.actionAttr, optionsButton, activerow, "row");
                    }
                    else {
                        if (!gridInfo.kgrid.selectable) return;
                        updateRowSelectionState(gridInfo, activerow, true, false, true);
                        const $li = gridInfo.list.find(".entity-cvitem[data-uid=" + activerow.attr("data-uid") + "]");
                        let res = [];
                        let rows = XPortal.Grid.GetGridRowsByUid(grid, [$li.attr("data-uid")], true, res);
                        if (rows && rows.length)
                            $(rows).each(function () {
                                $(this).find(".service .state-checked").addClass("d-none");
                            });
                        restoreViewSelection(gridInfo, [$li.attr("data-u-uid")], false);
                        $targetEl.prop("checked", false);
                    }
                });
            }
            $(grid).on("click", ".k-checkbox.row-checkbox.selectable", function (e) {
                grid.trigger("grid.change", e);
            });
            $(grid).on("click", "table tbody tr td.service a[data-action='navigatetoerror']", onNavigateToError);
            $(grid).off("focusout").on("focusout", function (e) {
                var id = $(this).attr('data-id');
                if ($(e.relatedTarget).parents(".grid-parent").length > 0 || $(e.relatedTarget).closest('section[data-src="' + id + '"]').length > 0)
                    return;

                $(".k-state-selected", e.sender).removeClass("k-state-selected");
                $(".k-state-focused", e.sender).removeClass("k-state-focused");
            });
            initCopyPastRecord(gridInfo);
        },
        SaveDetail: function (grid, button) {
            const ginfo = XPortal.Grid.GetGridInfo(grid);
            const state = XPortal.Store.GetState();

            let modelName = XPortal.Store.GetParentModelName(ginfo.modelName);
            if (modelName && modelName.trim().length) {
                const pModel = XPortal.Store.GetModelByName(modelName);
                const form = $(pModel.model.selector);
                const options = { modelName, container: form, button, notClose: true, silentMode: false, doNotDisplayErrors: false, IsCreating: pModel.model.IsCreating ? true : false };
                XPortal.EditForm.SaveData(modelName, options).fail(function (args) {
                    XPortal.Localization.GetLocalizedStrings("XFModal.Error.Title", "XFModal.Error.Save.Body").then(function (items) {
                        XPortal.EditForm.ShowErrorMessage(null, items["XFModal.Error.Title"], items["XFModal.Error.Save.Body"]);
                    });
                });
            }
            else {
                setTimeout(function () {
                    XPortal.Loader.show({ selector: $(button), size: '3rem' });
                    XPortal.Store.SaveInlineItemsRefresh(true, true);
                    XPortal.Loader.hide({ selector: $(button) });
                }, 200);
            }
        },
        ProcessActionToolbar: function (grid, action, sender, ...args) {
            if ($(sender).hasClass("fa fa-thumbtack action")) return;
            if (!action) return console ? console.error("grid action is not defined") : null;
            if (self[action] == null) return console ? console.error("Define action method: " + action) : null;

            try { grid.trigger("xportal.beforeaction", [action, sender, ...args]); } catch (err) { if (console) console.log("error in grid: beforeaction!", err) }
            const result = self[action](grid, $(sender), ...args);
            try { grid.trigger("xportal.afteraction", [action, sender, ...args]); } catch (err) { if (console) console.log("error in grid: afteraction!", err) }

            if (result === false)
                XPortal.Localization.GetLocalizedStrings("XFModal.Error.Title", "XFModal.Error.Grid.NoSelection", "XFModal.Error.Compare.NoSelection").then(function (items) {
                    XPortal.Modal.alert({
                        headerText: items["XFModal.Error.Title"],
                        alertText: items[action === "Compare" ? "XFModal.Error.Compare.NoSelection" : "XFModal.Error.Grid.NoSelection"]
                    });
                });

        },
        //process action from dropdown menu
        ProcessAction: function (param, uid) {
            var action = $(param).attr("data-action");
            if (!action) return console ? console.error("grid action is not defined") : null;
            if (self[action] == null) return console ? console.error("Define action method: " + action) : null;
            self[action]($(param).closest("div.k-grid.k-widget.k-display-block"), $(param), uid.trim());
        },
        InitIndividualActions: function (gridInfo, settings) {
            _.each(settings.columns || [], function (col) {
                if (!col.filterable || col.filterable === false)
                    col.filterable = settings.pageable.filter;
            });
            InitContextMenu(getIndividualCommands(gridInfo, settings), settings, gridInfo);
            self.InitFirstContentView(gridInfo);
        },
        Select: function (grid, btn, indRow, where) {
            let ginfo = XPortal.Grid.GetGridInfo(grid);
            var gridId = ginfo.nodeId;
            if (where.indexOf("head") >= 0) {
                var tableRow = grid.find("table tr");
                if (self.actionmodels[gridId].selectActOpts.allSelected === true) {
                    _.each(tableRow, xtr => updateRowSelectionState(ginfo, $(xtr), false, true));
                    self.actionmodels[gridId].selectActOpts.set("allSelected", false);
                }
                else {
                    _.each(tableRow, xtr => updateRowSelectionState(ginfo, $(xtr), true, false));
                    self.actionmodels[gridId].selectActOpts.set("allSelected", true);
                }
            } else {
                if (indRow && indRow.length > 0) {
                    _.each(indRow, function (x) {
                        let xel = $(x);
                        var checkState = xel.find(".service .state-checked");
                        if (checkState.length < 1) return;
                        var isSel = !checkState.is(".d-none") && xel.find(".service .state-unchecked.d-none").length > 0 ? true : false;
                        updateRowSelectionState(ginfo, xel, !isSel, isSel, true);
                    });
                    self.UpdateSelectAllCheckbox(grid);
                }
            }
            restoreViewSelection(ginfo, null, true);
        },
        RestoreSelection: function (ginfo, btn) {
            restoreGridSelection(ginfo);
        },
        Collapse: function (grid) {
            let kgrid = grid.data("kendoGrid");
            let gridId = kgrid.options.pageData.nodeId;
            if (self.actionmodels[gridId].collapsedOptions.collapsed === false) {
                self.ChangeCollapseState(grid, true);
            }
            else {
                self.ChangeCollapseState(grid, false);
            }

        },
        ChangeCollapseState: function (grid, isCollapse) {
            let kgrid = grid.data("kendoGrid");
            let fixedRows = kgrid.lockedTable[0].rows;
            let gridId = kgrid.options.pageData.nodeId;

            for (let i = 0; i < fixedRows.length; i++) {
                let $this = $(fixedRows[i]);
                if ($this.hasClass('k-grouping-row')) {
                    row = kgrid.tbody.find(">tr.k-grouping-row").eq(i);
                    if (isCollapse) {
                        kgrid.collapseGroup($this);
                    }
                    else {
                        kgrid.expandGroup($this);
                    }
                    self.actionmodels[gridId].collapsedOptions.set("collapsed", isCollapse);
                }
            }
        },
        AddInline: function (grid, modifyRecord) {
            var gridData = grid.data("kendoGrid");
            var modelName = XPortal.Store.GetModelByNodeId(gridData.options.pageData.nodeId);
            if (!XPortal.GridInlineEditing.ValidateGridModel(modelName)) {
                var result = $.Deferred();
                XPortal.Modal.alert({
                    headerText: gridData.options.messages.addinline.notvalidrowavailabletitle,
                    alertText: gridData.options.messages.addinline.notvalidrowavailablemessage
                }, function (modalResult) {
                    result.reject();
                });

                return result.promise();
            }

            return XPortal.GridInlineEditing.AddInlineRecord(grid, modifyRecord);
        },
        AddNew: function (grid, commandElement) {
            XPortal.GridActions.ShowPage({
                grid: grid,
                action: XPortal.EditForm.SetNewRecordLocationUrl
            });
        },
        Edit: function (grid, btn, selrows, data) {
            let itemObj = XPortal.Grid.GetGridDataRowItem(XPortal.Grid.GetGridInfo(grid), $(selrows)) || data;
            let rowid = XPortal.Template.GetObjPropValueByName(itemObj, "uniqueid");
            XPortal.GridActions.ShowPage({ grid: grid, uid: rowid, action: XPortal.EditForm.SetEditLocationUrl });
        },
        ShowPage: function (options) {
            XPortal.GridActions.AskBeforeMove(options).then(function onDoneAskQuestions(op) {
                const isYes = op.result === "yes";
                const modelName = XPortal.Store.getTopModelNameToSave();
                XPortal.Store.ForceCloseForm(!isYes);
                if (!isYes) {
                    var model = modelName ? XPortal.Store.GetModelByName(modelName) : null;
                    if (model) XPortal.Store.ClearItemToSave(model);
                    return options.action.apply(this, [options, window.location.href]);
                }
                XPortal.EditForm.SaveData(modelName, { doNotDisplayErrors: false }).then(function () {
                    var returnUrl = XPortal.EditForm.ModifyUrlAfterNewRecordSave(window.location.href);
                    options.action.apply(this, [options, returnUrl]);
                }).fail(function () {
                    XPortal.Localization.GetLocalizedStrings("XFModal.Error.Title", "XFModal.Error.Save.Body").then(function (items) {
                        XPortal.EditForm.ShowErrorMessage(null, items["XFModal.Error.Title"], items["XFModal.Error.Save.Body"]);
                    });
                });
            });
        },
        GetViewModelByUid: function (grid, rowsUidList) {
            var kgrid = grid.data("kendoGrid");
            var gridView = kgrid.dataSource.data();
            var uniqueIdList = [];
            var alias;
            rowsUidList.forEach(function (uid) {
                let viewModel = gridView.find(el => (uid && el.UniqueId == uid.trim() || el.uid === uid));
                if (!viewModel && gridView.find(el => el.hasOwnProperty("items"))) { // grouping in grid
                    $.each(gridView, function (index, element) {
                        viewModel = element.items.find(el => (uid && el.UniqueId == uid.trim() || el.uid === uid));
                        if (viewModel)
                            return false;
                    });
                }
                if (viewModel) {
                    if (!alias) alias = viewModel.EntityAlias;
                    uniqueIdList.push(viewModel.UniqueId ? viewModel.UniqueId : viewModel.uniqueid);
                }
            });
            uniqueIdList = uniqueIdList.reduce((array, item) => (typeof item !== typeof undefined && array.push(item), array), []);
            return {
                Items: uniqueIdList, EntityAlias: alias
            };
        },
        NotificationSubscription: function (grid, btn, activerows) {
            var gridInfo = XPortal.Grid.GetGridInfo(grid);
            if (btn.hasClass("d-busy")) return;
            var activerows = activerows || self.GetActiveRows(gridInfo, true);
            var selectedrowsIds = (activerows.toArray ? activerows.toArray() : activerows).map(row => $(row).attr("data-uid")).reduce((p, f) => ((p.indexOf(f) < 0) && p.push(f), p), []);
            var selIdsRequest = selectedrowsIds.length > 0 ? self.GetViewModelByUid(grid, selectedrowsIds) : null;
            if (!selIdsRequest || !selIdsRequest.Items || selIdsRequest.Items.length < 1) {
                return XPortal.Modal.alert({ headerText: gridInfo.kgrid.options.messages.notificationsubscription.warningtitle, alertText: XPortal.GridActions.GetWarningMsg(grid.closest(".grid-parent").find(".toolbar")) });
            }
            var gridNotifications = XPortal.Grid.AssignedNotificationsItems.find(i => i.viewId == gridInfo.nodeId);
            var subscriptionUrl = grid.attr("data-addnotification-url");

            if (gridNotifications && gridNotifications.assignedNotifications) {
                if (gridNotifications.assignedNotifications.indexOf(selIdsRequest.Items[0]) > -1) {
                    subscriptionUrl = grid.attr("data-remnotification-url");
                    addAction = false;
                }
            }

            if (!subscriptionUrl) return;
            var params = { relatedUidList: selIdsRequest.Items, relatedAlias: selIdsRequest.EntityAlias, entityAlias: "PortalNotifications", NodeId: grid.attr("data-id"), RelatedListId: grid.attr("data-id") };
            // get view model for toolbar item refresh
            btn.addClass("d-busy");
            XPortal.Notificator.AjaxCall({ element: btn, data: kendo.stringify(params), url: subscriptionUrl }, function onSucessResult(element, data) {
                if (data.State < 0) return XPortal.Modal.alert({ headerText: grid.data("kendoGrid").options.messages.notificationsubscription.warningtitle, alertText: data.Errors ? data.Errors.join() : "" });

                if (gridNotifications && gridNotifications.assignedNotifications) {
                    if (data.Operation === "add") gridNotifications.assignedNotifications = gridNotifications.assignedNotifications.concat(data.RelatedItemsResult.Items.map(i => i.UniqueId));
                    else data.RelatedItemsResult.Items.forEach(function (elem) {
                        gridNotifications.assignedNotifications.splice(gridNotifications.assignedNotifications.indexOf(elem.UniqueId), 1);
                    });
                }
            }, function onDone() {
                btn.removeClass("d-busy");
                XPortal.Notificator.MarkAssignedNotifications(gridInfo);
            });
        },
        IsDNotifOn: function (gid, forRow, forstate) {
            if (!forRow) return false;
            if (!gid) return false;
            var nsttgs = XPortal.Grid.AssignedNotificationsItems.find(i => i.viewId == gid) || { assignedNotifications: [] };
            var state = nsttgs.assignedNotifications.indexOf(forRow.UniqueId) > -1;
            if (forstate) return state ? 'notif-active' : 'notif-active d-none';
            if (!forstate) return !state ? 'notif-not-active' : 'notif-not-active d-none';
        },
        AskBeforeMove: function (params) {
            var dfd = $.Deferred();
            var state = XPortal.Store.GetState() || { editParameters: {} };
            var editParams = state.editParameters || {};
            editParams.IsChanged = XPortal.Store.IsEntityToSavePresent(state);

            var modalParams = {
                isNewItem: editParams ? editParams.IsCreating : false,
                isFormWasChanged: editParams ? editParams.IsChanged : false
            };
            $.extend(modalParams, params || {});

            if (XPortal.EditForm.SaveInProgress() || XPortal.Store.HasInProgressEvents()) {
                var $popup = $("#events-inprogress-popup");
                var $headerText = $("#events-inprogress-popup-header").addClass('d-none').text();
                $popup.find(".modal-header-cnt").html("<h4 class='modal-title'>" + $headerText + "</h4>");
                $popup.modal('show');
                dfd.reject();
                return dfd.promise();
            }

            XPortal.EditForm.changesAlreadyRejected = false;
            XPortal.GridInlineEditing.changesAlreadyRejected = false;

            if (modalParams.isNewItem
                || modalParams.isFormWasChanged
                || !XPortal.GridInlineEditing.ValidateAllGridModels()) {
                $.when(self.AlertUnsavedChanges(modalParams)).then(function (modalResult) {
                    XPortal.EditForm.changesAlreadyRejected = modalResult.result === "no";
                    XPortal.GridInlineEditing.changesAlreadyRejected = modalResult.result === "no";

                    dfd.resolve(modalResult);
                });
            } else {
                modalParams.result = "no";
                dfd.resolve(modalParams);
            }
            return dfd.promise();
        },
        Delete: function (grid, $actionObj, activerows) {
            if (activerows.length === 0) return false;
            const ownerOnly = $($actionObj).attr("data-owners-only") === "1";
            const defDelUrl = $(grid).attr("data-del-url");
            XPortal.GridActions.DeleteRecords(getSelectedObjects(grid, true, activerows), grid, $actionObj.attr("data-deleteRecords") || defDelUrl, ownerOnly);
            return true;
        },
        Compare: function (grid, $actionObj, activerows) {
            var objCompare = getSelectedObjects(grid, true, activerows);
            if (objCompare.length < 2) return false;
            XPortal.GridActions.ShowCompareForm({ button: $actionObj, rows: objCompare, grid: grid });
            return true;
        },
        ShowCompareForm: function (options) {
            var deferred = $.Deferred();
            var gridInfo = XPortal.Grid.GetGridInfo(options.grid);
            if (!gridInfo.kgrid || !gridInfo.kgrid.options) return;
            var nodeId = gridInfo.kgrid.options.pageData.nodeId;

            var compareTmpl = $(options.button).find(".compareGridTemplate");
            var compareHtml = compareTmpl.length ? compareTmpl.html() : $(".compareGridTemplate").html();
            if (!compareHtml) return;
            compareHtml = compareHtml.replace("[[columnwidth]]", $(options.button).attr("data-col-width"));
            var compareTemplate = kendo.template(compareHtml);
            var data = [];

            var userColumns = $(options.button).attr("data-opts");
            if (userColumns) var fields = JSON.parse(userColumns);

            if (!fields || !fields.Fields || fields.Fields.length < 1) {
                fields = gridInfo.kgrid.columns.map(function (col) {
                    return {
                        FieldName: col.field.toLowerCase(), Title: col.title, Template: col.template, Type: col.attributes["data-ctype"]
                    };
                });
                if (fields.length > 0 && fields[0].FieldName === "selectable") fields.shift();
            } else {
                fields = fields.Fields;
                fields.forEach(function (field) {
                    var numericTypes = ["int", "int32", "int64", "long", "number", "decimal", "float"];
                    if (numericTypes.indexOf(field.TypeName.toLowerCase()) > -1) field.TypeName = "number";

                    if (field.Format && field.Format !== "" && field.Format.length > 0) {
                        field.Format = field.Format.indexOf("script:") > -1 || field.TypeName === "number" ? field.Format : "{0:" + field.Format + "}";
                    }
                    field.Template = '#=XPortal.Grid.GetTemplateValue(data,"' + field.TypeName.toLowerCase() + '","' + encodeURIComponent(field.FieldName.toLowerCase()) + '","' + encodeURIComponent(field.Format ? field.Format.replace(/\"/g, '\\"') : '') + '",' + nodeId + ')#';
                });
            }

            fields = fields.filter(function (item) {
                return item.Type != "calendarcolumn";
            });

            fields.forEach(function (field) {
                data.push([field.Title ? field.Title : field.FieldName].concat(options.rows.map(function (row) {
                    if (field.Template) {
                        var template = kendo.template(field.Template);
                        var data = template(row);
                        return data;
                    } else return row[field.FieldName];
                })));
            });
            var title = options.button.attr("data-title");
            var gridTitle = options.grid.prev().find("[data-original-title]").attr("data-original-title");
            title = title.split("[[gridTitle]]").join(gridTitle ? gridTitle : "");
            title = XPortal.Template.ReplaceFormatString(title, null, options.rows[0], {});
            var formText = compareTemplate(data);
            var parameters = {
                options: {
                    showModal: true,
                    IsForm: true,
                    confirmationText: formText,
                    headerText: title,
                    modalType: 'dymanic-width'
                }
            };

            XPortal.Modal.confirm(parameters);

            $('#modalBox .table-compare').kendoTooltip({
                filter: '.tdcell',
                position: 'left',
                width: 200,
                showAfter: 1500,
                content: function (e) {
                    return e.target.html();
                }
            });

            // We need show shadow if table has scroll
            setTimeout(function () {
                var $tableCompareWrapper = $('#modalBox .table-compare');
                var $tableCompare = $tableCompareWrapper.find('.table');
                var tableCompareWrapperWidth = $tableCompareWrapper.width();
                var tableCompareWidth = $tableCompare.width();

                if (tableCompareWrapperWidth < tableCompareWidth) {
                    $tableCompare.addClass('table-has-scroll')
                }

                $tableCompareWrapper.on('scroll', function () {
                    var scrollLeft = $tableCompareWrapper.scrollLeft();
                    if (scrollLeft === 0) {
                        $tableCompare.removeClass('table-scrolled');
                    } else {
                        $tableCompare.addClass('table-scrolled');
                    }
                });
            }, 300);

            return deferred.promise();
        },
        DeleteRecords: function (objects, grid, action, ownersOnly) {
            var removedCount = 0;

            if (!(action.length > 0 && self.ajaxGetResponse)) return;
            const ginfo = XPortal.Grid.GetGridInfo(grid);
            const gridData = ginfo.kgrid;
            if (!XPortal.Account.Name) return XPortal.Modal.alert({ headerText: gridData.options.messages.delete.warningtitle, alertText: gridData.options.messages.delete.notLoggedIn });
            var items = [];
            _.each(objects, function (o) {
                if (typeof o._wasInlineSaved === typeof undefined && o._newInlineRecord) {
                    gridData.dataSource.remove(o);

                    var modelName = XPortal.Store.GetModelByNodeId(gridData.options.pageData.nodeId);
                    var model = XPortal.Store.GetModelByName(modelName);
                    XPortal.Store.ClearItemToSave(model, o);

                    removedCount++;
                }
                else if ((!ownersOnly || o.IsOwnRecord) || o._newInlineRecord) {
                    items.push({
                        UniqueId: o.UniqueId === null ? o.uniqueid : o.UniqueId,
                        EntityAlias: o.EntityAlias
                    });
                }
            });
            if (items.length === 0) {
                if (removedCount === 0) { //case when nothing selected
                    XPortal.Modal.alert({
                        headerText: gridData.options.messages.delete.warningtitle,
                        alertText: gridData.options.messages.delete.notCreator
                    });
                }
                self.UpdateSelectAllCheckbox(grid, true);
                return;
            }
            var headers = { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() };
            $.each(grid.closest(".grid-parent").find("input:hidden"), function (ix, ixel) {
                var xel = $(ixel);
                if (xel.attr("name")) headers[xel.attr("name")] = xel.val();
            });

            self.ajaxGetResponse = false;
            $.ajax({
                type: "post", cache: false, url: XPortal.Utils.EnsureInProfile(action), headers: headers, contentType: 'application/json; charset=utf-8',
                data: JSON.stringify({ NodeId: gridData.options.pageData.nodeId, RequestModels: items, ParentInfo: XPortal.Grid.GetModelParentInfo(ginfo.modelName) }),
                success: function (response, status, xhr) {
                    XPortal.Main.OnPortalFormAjaxComplete(response, status, xhr);
                    self.ajaxGetResponse = true;
                },
                error: function (xhr, status, error) {
                    console.log('DeleteRecords ajax error!');
                    self.ajaxGetResponse = true;
                },
            });
        },
        AfterRemove: function (response, status, xhr) {
            var grid = $("#entity-grid-" + response.Requested.NodeId);
            var gridData = grid.data("kendoGrid");
            if (gridData) {
                gridData.dataSource.read().then(function () {
                    var modelName = XPortal.Store.GetModelByNodeId(gridData.options.pageData.nodeId);
                    XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.DELETED_ENTITY, entityList: response.ResponseModels, model: modelName });
                });
            }
            else { //probably detail form - will close it
                XPortal.EditForm.CloseDetails();
            }
            XPortal.Modal.closeModal();
            if (response.State) {
                var message = response.Errors[0] + "\n";
                $.each(response.ResponseModels, function (ind, model) {
                    if (model.State === 0) return;
                    message += (ind + 1) + "-" + model.Errors.join() + "\n";
                });
                if (message.length !== 0)
                    XPortal.Modal.alert({
                        headerText: gridData.options.messages.delete.warningtitle,
                        alertText: message
                    });
            }
            self.UpdateSelectAllCheckbox(grid, true);

        },
        EditMode: function (grid, commandElement, isEditMode = null) {
            if (!XPortal.Account.Name) {
                XPortal.Modal.alert({
                    headerText: grid.data("kendoGrid").options.messages.editmode.warningtitle,
                    alertText: grid.data("kendoGrid").options.messages.editmode.notLoggedIn
                });
                return new $.Deferred().reject();
            }
            setGridContentView(grid);
            isEditMode = isEditMode === true || isEditMode === false ? isEditMode : XPortal.GridInlineEditing.GetEditMode(grid) === "grid-detail";
            var inlineeditingenabled = grid.getKendoGrid().columns.some(function (value) { return value.canedit || value.cancreate; }) === true;
            if (!inlineeditingenabled) {
                XPortal.Modal.alert({
                    headerText: grid.data("kendoGrid").options.messages.editmode.warningtitle,
                    alertText: grid.data("kendoGrid").options.messages.editmode.noeditablecolumns
                });
                return new $.Deferred().reject();
            }

            var gridData = grid.data("kendoGrid");
            var modelName = XPortal.Store.GetModelByNodeId(gridData.options.pageData.nodeId);
            if (!isEditMode && !XPortal.GridInlineEditing.ValidateGridModel(modelName)) {
                var result = self.AlertUnsavedChanges({ isNewItem: false, isFormWasChanged: true }).then(function (modalResult) {
                    var model = modelName ? XPortal.Store.GetModelByName(modelName) : null;
                    if (modalResult.result === "yes") {
                        if (model) XPortal.Store.ClearItemToSave(model);
                        return XPortal.GridInlineEditing.SetEditMode(grid, isEditMode ? "grid-inline" : "grid-detail", commandElement);
                    }
                    XPortal.Store.ClearItemToSave(model);
                    return new $.Deferred().reject();
                });

                return result.promise();
            }

            return XPortal.GridInlineEditing.SetEditMode(grid, isEditMode ? "grid-inline" : "grid-detail", commandElement);
        },
        ExportToExcel: function (grid, button, activerows) {
            var ginfo = XPortal.Grid.GetGridInfo(grid);
            initExportTo(ginfo, button, activerows, function (exportOptions, isAll) {
                self._ExportToExcel(ginfo, button, exportOptions);
            });
        },
        _ExportToExcel: function (ginfo, button, ots) {
            toolBarSpinner(null, true, true);
            const excel = ginfo.kgrid.options.excel;
            excel.allPages = false;
            ginfo.kgrid.one("excelExport", function (e) {
                e.button = button;
                XPortal.GridActions.FilterExcelData(e, ginfo.grid);
            });
            excel.fileName = getfileNameforExport(ginfo.kgrid, ".xlsx", ots);
            if (ots.selection && ots.selection.length > 0) {
                ots.CustomFilter = function (items, rq) {
                    return ots.selection;
                };
            }
            const exporter = new XPortal.ExcelExporter(ots);
            exporter.workbook().then($.proxy(function (book, data) {
                ginfo.kgrid.dataSource._requestInProgress = false;
                toolBarSpinner(null, false, true);
                const workbook = new kendo.ooxml.Workbook(book);
                XPortal.GridActions.FilterNew(ginfo.kgrid, book, workbook);
                saveAs(workbook.toDataURL(), (book.fileName || excel.fileName) || 'data.xlsx');
            }, this));
            return true;
        },
        FilterExcelData: function (e, grid, selectedRows) {
            var items = selectedRows ? selectedRows.map(o => o.UniqueId === null ? o.uniqueid : o.UniqueId) : null;
            var griddata = grid ? grid.data("kendoGrid") : this;
            var dataColumns = griddata.columns.filter(col => col.attributes && col.attributes["data-ctype"] === "date").map((col, index) => {
                col._index = index;
                return col;
            }).filter(col => col.attributes && col.attributes["data-ctype"] === "date");

            var newrows = [];
            const headerRow = e.workbook.sheets[0].rows[0];
            newrows.push(headerRow);
            dataColumns.map(dataColumn => {
                let cell = headerRow.cells.find(c => c.value === dataColumn.title);
                if (cell)
                    dataColumn._index = headerRow.cells.indexOf(cell);
                return dataColumn;
            });

            if (newrows[0].cells[0].value === "selectable") { //remove selectable column caption
                newrows[0].cells.splice(0, 1); //remove first column      
                var hasSelectableColumn = true;
            }
            if (newrows[0].type === "header") {
                let selectableCell = newrows[0].cells.find(c => c.value === "selectable");
                if (selectableCell) selectableCell.value = "";
            }
            var counter = 1;
            if (e.workbook.sheets[0].rows.find(r => r.type === "group-footer"))
                var footerPresent = true;
            $.each(e.data, function (i, item) {
                var isFound = false;
                if (item.hasOwnProperty("items")) {
                    let subItems = item.items.map(i => i.UniqueId ? i.UniqueId : item.uniqueid);
                    $.each(subItems, function (ind, uid) {
                        if (!items || items.indexOf(uid) > -1) {
                            if (!isFound) { //insert header
                                newrow = e.workbook.sheets[0].rows[counter];
                                newrows.push(newrow);
                                isFound = true;
                            }
                            var newrow = e.workbook.sheets[0].rows[counter + ind + 1];
                            $.each(dataColumns, function (i, formatCol) {
                                if (newrow.cells[formatCol._index].value) {
                                    newrow.cells[formatCol._index].value = moment(newrow.cells[formatCol._index].value).format("YYYY-MM-DD");//XSD Date and Time Data Types
                                }
                            });
                            if (hasSelectableColumn) newrow.cells.splice(0, 1);
                            newrows.push(newrow);
                        }
                    });
                    isFound = false;
                    counter += item.items.length;
                    if (footerPresent) counter++;
                }
                else if (!items || (items.includes(item.UniqueId) || items.includes(item.uniqueid))) {
                    var newrow = e.workbook.sheets[0].rows[counter];
                    $.each(dataColumns, function (i, formatCol) {
                        if (newrow.cells[formatCol._index].value) {
                            newrow.cells[formatCol._index].value = moment(newrow.cells[formatCol._index].value).format("YYYY-MM-DD");//XSD Date and Time Data Types
                        }
                    });
                    if (hasSelectableColumn) newrow.cells.splice(0, 1);
                    newrows.push(newrow);
                }
                counter++;
            });
            e.workbook.sheets[0].rows = newrows;
            if (hasSelectableColumn) e.workbook.sheets[0].columns.splice(0, 1);
            if (e.button) toolBarSpinner(e.button, false);
        },
        FilterNew: function (griddata, book) {
            var headerRow = book.sheets[0].rows[0];
            var dateTimeColumns = griddata.columns
                .filter(function (col) { return !col.hidden && col.attributes != null; })
                .map(function (col, index) {
                    col._index = index;
                    return { t: col.attributes["data-ctype"], col: col };
                })
                .filter(function (col) { return col.t === "date" || col.t === "datetime" })
                .map(function (dataColumn) {
                    let cell = headerRow.cells.find(function (c) { return c.value === dataColumn.col.title; });
                    if (cell) dataColumn.col._index = headerRow.cells.indexOf(cell);
                    return dataColumn.col;
                });
            for (var rowIndex = 1; rowIndex < book.sheets[0].rows.length; rowIndex++) {
                var row = book.sheets[0].rows[rowIndex];
                for (var cellIndex = 0; cellIndex < row.cells.length; cellIndex++) {
                    var cell = row.cells[cellIndex];
                    if (XPortal.GridActions.IsDateValue(cell.value)) {
                        frmt = 'l';
                        valueParsed = "";
                        var col = dateTimeColumns.find(c => c._index == cellIndex);
                        if (col) {
                            var cll = book.sheets[0].rows[rowIndex].cells[cellIndex];
                            if (col.format.length > 0 && col.format.indexOf("{0:") > -1) {
                                cll.format = col.format.replace("{0:", "").slice(0, -1);
                                cll.value = XPortal.GridActions.JSDateToExcelDate(cll.value);
                            }
                        }
                    }
                }
            }

            // Reformatting title for header row
            for (var headerCellIndex = 0; headerCellIndex < headerRow.cells.length; headerCellIndex++) {
                var headerCell = headerRow.cells[headerCellIndex];
                var column = griddata.columns.find(c => c.title === headerCell.value);
                if (column) {
                    headerCell.value = column.headerAttributes["title"] ? column.headerAttributes["title"] : column.title;
                }
            }
        },
        JSDateToExcelDate: function (inDate) {
            //a bit of magic
            // 25569.0 is a difference between January 1, 1900 (actual dates start in Excel) and January 1, 1970, 00:00:00 UTC 
            // (the Unix epoch) which used for JS dates ticks
            //see more for Excel date systems at 
            //https://support.office.com/en-us/article/date-systems-in-excel-e7fe7167-48a9-4b96-bb53-5612a800b487
            //they have 2 systems (The 1900 date system and The 1904 date system) and code below will not work for 1904
            //this option can be adjusted in Excel 
            return 25569.0 + ((inDate.getTime() - (inDate.getTimezoneOffset() * 60 * 1000)) / (1000 * 60 * 60 * 24));
        },
        IsDateValue: function (date) {
            return date instanceof Date && !isNaN(date);
        },
        PrepareGridDataSourceForExport: function (idataSource, options) {
            const opts = $.extend({}, idataSource.options, {
                page: options.allPages ? 0 : idataSource.page(),
                filter: idataSource.filter(),
                pageSize: options.allPages ? idataSource.total() : idataSource.pageSize() || options.pageSize,
                sort: idataSource.sort(),
                group: idataSource.group(),
                aggregate: idataSource.aggregate()
            });
            const allDataSource = new idataSource.constructor(opts);
            allDataSource.transport.CustomFilter = options.CustomFilter ? options.CustomFilter : idataSource.CustomFilter;
            allDataSource.transport._fromBatchExport = true;
            allDataSource._total = idataSource._total;
            const data = allDataSource.data();
            if (data.length > 0) {
                //idataSource._data = data;
                var transport = idataSource.transport;
                if (idataSource._isServerGrouped() && transport.options && transport.options.data) {
                    transport.options.data = null;
                }
            }
            return allDataSource;
        },
        ExportToCsv: function (grid, button, activerows) {
            var ginfo = XPortal.Grid.GetGridInfo(grid);
            initExportTo(ginfo, button, activerows, function (exportOptions, isAll, kgrid) {
                var fileName = getfileNameforExport(kgrid, ".csv", exportOptions);
                var opts = { grid: kgrid, fileName, button, selectedItems: null, data: null };
                if (isAll) {
                    toolBarSpinner(null, true, true);
                    checkExportActivity(button);
                    var dataSource = XPortal.GridActions.PrepareGridDataSourceForExport(kgrid.dataSource, { allPages: true });
                    window.setTimeout(function () {
                        dataSource.fetch().then($.proxy(function () {
                            opts.data = this.view();
                            XPortal.GridActions.ToCSV(opts);
                            toolBarSpinner(null, false, true);
                        }, dataSource));
                    }, 100);
                    return;
                } else {
                    checkExportActivity(button);
                    opts.selectedItems = GetCheckedRowUidList(grid).map(o => o.UniqueId === null ? o.uniqueid : o.UniqueId);
                    opts.data = kgrid.dataSource._view;
                    XPortal.GridActions.ToCSV(opts);
                }
            }, ".csv");
            return true;
        },
        ToCSV: function (options) {
            var csv = '';
            var columns = options.grid.columns.map(function (col) { return { format: col.format, field: col.attributes["data-cfield"], type: col.attributes["data-ctype"], title: col.headerAttributes["title"] ? col.headerAttributes["title"] : col.title } }).filter(col => col.field && !col.hidden);
            var items = [];
            options.data.forEach(function (row) {
                if (row.hasOwnProperty("items")) {
                    items = items.concat(row.items);
                }
                else {
                    items.push(row);
                }
            });
            //add the header row
            if (columns.length > 0) {
                columns.forEach(function (col, index) {
                    if (items[0].hasOwnProperty(col.field)) {

                        let value = col.title.replace(/"/g, '""');
                        csv += '"' + value + '"';
                        if (index !== columns.length - 1) {
                            csv += ",";
                        }
                    }
                });
                csv += "\r\n";
            }
            //add each row of data            
            for (var row in items) {
                var uid = items[row].UniqueId == null ? items[row].uniqueid : items[row].UniqueId;
                if (options.selectedItems && options.selectedItems.indexOf(uid) < 0) continue;
                columns.forEach(function (col, ind) {
                    if (items[row].hasOwnProperty(col.field)) {
                        var value = items[row][col.field];
                        if (value === null || typeof value === typeof undefined) {
                            value = "";
                        } else if (value instanceof Date && col.type === "date") {
                            value = XPortal.Template.date(col.format ? col.format : "{0:YYYY-MM-DD}", value);
                        } else if (value instanceof Date && col.type === "datetime") {
                            value = kendo.format(col.format ? col.format : "{0:YYYY-MM-DDTHH:mm:ss}", value);
                        } else {
                            value = value.toString();
                        }
                    }
                    else {
                        value = "";
                    }
                    value = "\"" + value.replace(/"/g, "\"\"") + "\"";
                    csv += value + (ind + 1 < columns.length ? ',' : '\r\n');
                });
            }
            XPortal.GridActions.SaveToFile(options.fileName, "text/csv", csv);
            if (options.button) toolBarSpinner(options.button, false);
        },
        SaveToFile: function (filename, type, text) {
            // Set up the link
            var link = document.createElement("a");
            link.setAttribute("target", "_blank");
            if (Blob !== undefined) {
                var blob = new Blob([text], { type: type });
                link.setAttribute("href", URL.createObjectURL(blob));
            } else {
                link.setAttribute("href", "data:text/plain," + encodeURIComponent(text));
            }
            link.setAttribute("download", filename);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        ExportToPdf: function (grid, button, activerows) {
            var ginfo = XPortal.Grid.GetGridInfo(grid);
            initExportTo(ginfo, button, activerows, function (exportOptions, isAll, kgrid) {
                kgrid.options.pdf.fileName = getfileNameforExport(kgrid, ".pdf", exportOptions);
                checkExportActivity(button);
                toolBarSpinner(null, true, true);
                kgrid.one("pdfExport", function (e) {
                    self.FilterPdf({ grid: grid, e: e, button: button, selectedrows: exportOptions.selection });
                });
                kgrid.options.pdf.allPages = isAll;
                exportOptions.exportListInstead = ginfo.grid.hasClass("entity-grid-hidden") ? true : false;
                kgrid.options.pdf.landscape = !exportOptions.exportListInstead;
                new XPortal.pdfExporter(exportOptions).saveAsPDF(ginfo, exportOptions).then(function (root) {
                    toolBarSpinner(null, false, true);
                });
            }, ".pdf");
        },
        FilterPdf: function (options) {
            if (options.selectedrows && options.selectedrows.length > 0) {
                var uidList = options.selectedrows.map(r => r.uid);
                var rows = options.grid.find("table tr");
                for (var i = 0; i < rows.length; i++) {
                    var row = rows[i];
                    var uid = row.dataset["uid"];
                    if (uid && !uidList.includes(uid))
                        $(row).addClass("d-none");
                }
                options.e.promise.done(function () {
                    options.grid.find("tr.d-none").each(function () {
                        $(this).removeClass("d-none");
                    });
                    if (options.button) toolBarSpinner(options.button, false);
                });
            } else if (options.button) toolBarSpinner(options.button, false);
        },
        Reload: function (grid, commandElement) {
            $.when(XPortal.GridInlineEditing.SaveEmAll(grid, commandElement)).done(function () {
                grid.data("kendoGrid").dataSource.read();
                grid.data("kendoGrid").refresh();
            });
        },
        Print: function (grid) {
            var printableContent = '',
                win = window.open('', '', 'width=800, height=500, resizable=1, scrollbars=1'),
                doc = win.document.open();

            var htmlStart =
                '<!DOCTYPE html>' +
                '<html>' +
                '<head>' +
                '<meta charset="utf-8" />' +
                '<title>' + getfileNameforExport(grid.data("kendoGrid")) + '</title>' +
                '<link href="/css/kendo/kendo.common-material.css" rel="stylesheet">' +
                '<link href="/css/kendo/kendo.material.css" rel="stylesheet">' +
                '<link href="/css/kendo/kendo.material.mobile.css" rel="stylesheet">' +
                '<style>' +
                'html { font: 11pt sans-serif; }' +
                '.k-grid { border-top-width: 0; }' +
                '.k-grid, .k-grid-content { height: auto !important; }' +
                '.k-grid-content { overflow: visible !important; }' +
                'div.k-grid table { table-layout: auto; width: 100% !important; }' +
                '.k-grid .k-grid-header th { border-top: 1px solid; }' +
                '.k-grouping-header, .k-grid-toolbar, .k-grid-pager > .k-link { display: none; }' +
                '</style>' +
                '</head>' +
                '<body>';

            var htmlEnd = '</body></html>';

            var gridHeader = grid.children('.k-grid-header');
            if (gridHeader[0]) {
                var thead = gridHeader.find('thead').clone().addClass('k-grid-header');
                printableContent = grid.clone()
                    .children('.k-grid-header').remove().end()
                    .children('.k-grid-content').find('table').first()
                    .children('tbody').before(thead)
                    .end()
                    .end()
                    .end()
                    .end()[0].outerHTML;
            } else {
                printableContent = gridElement.clone()[0].outerHTML;
            }

            doc.write(htmlStart + printableContent + htmlEnd);
            doc.close();
            win.document.body.onload = function () {
                win.print();
            };
        },
        Scheduler: function (grid, commandElement) {
            XPortal.GridCalendar.ButtonsPanel.togglePanel(grid, commandElement);
        },
        _closecolumnlistfunc: function (element) {
            element.removeClass("open");
            $("body").off("click.gridactions");
            setTimeout(function () {
                element.removeClass("right");
            }, 300);
        },
        _closecolumnlist: function (e, element) {
            XPortal.GridActions._closecolumnlistfunc(element);
        },
        _attachCloseMenuHandlers: function (element, wrapperClass) {
            $(".open:not(" + wrapperClass + ")").removeClass("open");
            $(element).off("click.gridactions").on("click.gridactions", function (event) {
                event.stopPropagation();
            });
            $("body").off("click.gridactions").on("click.gridactions", function (e) {
                if ($(e.target).closest('.k-animation-container').length) {
                    return;
                }

                if (!e.target.classList.contains("k-state-focused")) {
                    XPortal.GridActions._closecolumnlist(e, element);
                }
            });
            $(window).off("resize.gridactions orientationchange.gridactions").on("resize.gridactions orientationchange.gridactions", function () {
                XPortal.GridActions._closecolumnlistfunc(element);
            });
        },
        SetupVisibleColumns: function (grid, obj) {
            var gridData = grid.data("kendoGrid");
            var gridInfo = XPortal.Grid.GetGridInfo(grid);
            var wrapperClass = ".columns-list-wrapper";
            var $gridHeader = grid.closest(".grid-parent").find(".grid-action-header");
            var columnlist = $gridHeader.find(".desktop-inline .dropdown-item:not(.d-none) " + wrapperClass).first();
            var $toolbarButto =  grid.find(".service-toolbar-link[data-action=SetupVisibleColumns]");
            if (!columnlist.length) {
                columnlist = $gridHeader.find(".dots .dropdown-item:not(.d-none) " + wrapperClass).first();
            }

            if ($toolbarButto.length > 0) {
                const columnlistCloneClass = "columns-list-wrapper_in_grid-header";
                const $kGridHeader = $toolbarButto.parents('.k-grid-header')
                const kGridHeaderHeigth = $kGridHeader.outerHeight();
                const $dots = $kGridHeader.find('.dots.dropdown-dots-inited.show')
                const left = $dots.find('.dropdown-menu').width() + 45;
                if($kGridHeader.find(`.${columnlistCloneClass}`).length > 0) {
                    columnlist = $kGridHeader.find(`.${columnlistCloneClass}`).first().css('top', kGridHeaderHeigth)
                    if ($dots.length > 0) {
                        columnlist.css('left', left);
                    }
                } else {
                    const columnlistClone = columnlist.clone();
                    $kGridHeader.find('.columns-list-wrapper').remove();
                    $kGridHeader.append(columnlistClone);
                    columnlist = $kGridHeader.find(wrapperClass).first().addClass(columnlistCloneClass).css('top', kGridHeaderHeigth);
                    if ($dots.length > 0) {
                        columnlist.css('left', left);
                    }
                }
            }

            XPortal.GridActions._attachCloseMenuHandlers(columnlist, wrapperClass);

            gridcolumnmodel = new kendo.observable({
                columns: gridData.columns,
                visible: function (e) {
                    return !e.hasOwnProperty("hidden") || e.hidden == null || e.hidden == false;
                },
                onclick: function (e) {
                    if (e.currentTarget.checked)
                        gridData.showColumn(e.data.field);
                    else
                        gridData.hideColumn(e.data.field);
                    gridInfo.grid.find(".grid-service-dd.grid-service-dd-header").removeClass("width-calculated");
                    XPortal.Grid.updateColumnsWidth(gridInfo);
                }
            });
            kendo.unbind(columnlist);
            kendo.bind(columnlist, gridcolumnmodel);

            // XPortal.DropdownBtns.openDotsIfPanelInside(columnlist);



            if (!columnlist.hasClass("open")) {
                columnlist.addClass("open");
                if (columnlist.offset().left + columnlist.outerWidth() > $(window).width()) {
                    columnlist.addClass("right");
                }
            } else {
                XPortal.GridActions._closecolumnlistfunc(columnlist);
            }
        },
        OpenFilter: function (grid) {
            var wrapperClass = ".filters-list-wrapper.static";
            var kgridData = grid.data("kendoGrid");
            var gridId = kgridData.options.pageData.nodeId;
            let tabSelector = "#entity-grid-" + gridId;
            let $tab = $(tabSelector);
            if ($tab.length > 0) {
                $tab.parent().find(wrapperClass).css("display", "block");
            }
            var columnlist = grid.closest(".grid-parent").find(wrapperClass);
            XPortal.GridFiltering.BindFilters(grid, { element: columnlist }, true);
        },
        Filter: function (grid, obj) {
            var wrapperClass = ".filters-list-wrapper.action";
            var staticWrapperClass = ".filters-list-wrapper.static";
            $(wrapperClass).find('.unpinned-icon').click();

            if ($(staticWrapperClass).hasClass('open')) {
                XPortal.GridActions.actionmodels[grid[0].dataset.id].set("filterOpen", false);
                $(staticWrapperClass).removeClass('open');
                XPortal.Grid.ResizeGrid(grid);
            } else {
                $(staticWrapperClass).addClass('open');
                XPortal.GridActions.actionmodels[grid[0].dataset.id].set("filterOpen", true);
                var columnlist = grid.closest(".grid-parent").find(wrapperClass);
                XPortal.GridActions._attachCloseMenuHandlers(columnlist, wrapperClass);
                if (!columnlist.hasClass("open")) {
                    XPortal.GridFiltering.BindFilters(grid, { element: columnlist }, false);
                } else {
                    columnlist.toggleClass('open');
                }
                XPortal.Grid.ResizeGrid(grid);
            }
        },
        Download: function (grid, $actButton) {
            var downloadlinks = [];
            var gridInfo = XPortal.Grid.GetGridInfo(grid);
            var activerows = self.GetActiveRows(gridInfo);
            if (activerows.length === 0) {
                $('html').data('showprogress', 'yes');
                return false;
            }

            activerows.forEach(function (row) { downloadlinks = downloadlinks.concat($(row).find("td a.download").toArray()); });
            if (downloadlinks.length === 0) {
                $('html').data('showprogress', 'yes');
                XPortal.Modal.alert({
                    headerText: XPortal.GridActions.GetWarningMsg($actButton, "data-title"),
                    alertText: XPortal.GridActions.GetWarningMsg($actButton, "data-noattachments")
                });
                return;
            }
            if (downloadlinks.length === 0) return false;

            var params = {};
            var counter = 0;
            _.each(downloadlinks, function (link) {
                var url = $(link).attr('href');
                params[counter.toString()] = GetURLParameter(url, "id");
                counter++;
            });
            var url = $(downloadlinks[0]).attr('href');
            var action = $actButton.attr('data-downloadUrl');
            checkExportActivity($actButton);

            submitDynamicForm(action, {
                Id: _.toArray(params).join("_#_"),
                KeyField: GetURLParameter(url, "KeyField"),
                NodeId: GetURLParameter(url, "NodeId"),
                atttype: "zip",
                RequestVerificationToken: XPortal.Main.getAntiForgeryToken()
            }, "POST", "_self", false);

            return true;
        },
        GetXSelectedRows: function (grid, lockedAndUnlocked, rowids) {
            var selectedids = [];
            let result = [];
            grid.find(".service .state-checked").each(function () {
                if ($(this).is(".d-none")) return null;
                let row = $(this).closest("tr");
                let rowid = row.data("uid").toLowerCase();
                if (rowids) rowids.push(rowid);
                let iresult = XPortal.Grid.GetGridRowsByUid(grid, rowid, lockedAndUnlocked, selectedids);
                iresult.forEach(xi => result.push(xi));
            });
            return result;
        },
        GetActiveRows: function (gridInfo, setCheckForSelected) {
            var activeRow = updateRowSelectionState(gridInfo, gridInfo.grid.find(".k-state-selected:not(span)"), setCheckForSelected, false);
            var selectedrows = self.GetXSelectedRows(gridInfo.grid);
            if (activeRow.length !== 0 && selectedrows.length === 0)
                selectedrows.push(activeRow);
            return selectedrows;
        },
        GetCurSelectedRow: function (gridinfo, rowInternalDomElement, uniqueIds, skipKStateSelectedItem) {
            let rows = [];
            let selectedids = [];
            let result = [];
            const lockedAndUnlocked = true;
            if (!skipKStateSelectedItem) _.each(gridinfo.grid.find(".k-state-selected:not('span')"), xel => rows.push(xel));
            _.each(rowInternalDomElement ? XPortal.Grid.GetGridDataRow(gridinfo, rowInternalDomElement, gridinfo.grid) : [], xel => rows.push(xel));
            _.each(rows, function (xel) {
                let itemObj = XPortal.Grid.GetGridDataRowItem(gridinfo, $(xel));
                if (!itemObj) return
                let rowid = XPortal.Template.GetObjPropValueByName(itemObj, "uid");
                if (uniqueIds) uniqueIds.push(XPortal.Template.GetObjPropValueByName(itemObj, "uniqueid"));
                let iresult = XPortal.Grid.GetGridRowsByUid(gridinfo.grid, rowid, lockedAndUnlocked, selectedids);
                iresult.forEach(xi => _.each(xi, xii => result.push(xii)));
            });
            return $(result);
        },
        BindTableEventHandlers: function (grid) {
            var griddata = grid.data("kendoGrid");
            if (griddata.options.commands.hasOwnProperty("addinline") || griddata.options.commands.hasOwnProperty("edit")) {
                griddata.table.on('keydown', XPortal.GridInlineEditing.BindKeyboard);
                if (griddata.lockedTable)
                    try { griddata.lockedTable.on('keydown', XPortal.GridInlineEditing.BindKeyboard); } catch (e) { if (console) console.log(e); };
            }
        },
        UnbindTableEventHandlers: function (grid) {
            var griddata = grid.data("kendoGrid");
            if (griddata && (griddata.options.commands.hasOwnProperty("addinline") || griddata.options.commands.hasOwnProperty("edit"))) {
                griddata.table.off('keydown', XPortal.GridInlineEditing.BindKeyboard);
                if (griddata.lockedTable)
                    try { griddata.lockedTable.off('keydown', XPortal.GridInlineEditing.BindKeyboard); } catch (e) { if (console) console.log(e); };

                $(document).off('click.gridedit').on('click.gridedit', function (e) {
                    var $target = $(e.target);
                    if ($target.hasClass('tdcell')
                        || $target.closest('.k-edit-cell').length
                        || $target.closest('.navigate-to-error').length
                        || $target.closest('.combobox-btn-pgn').length) {
                        return;
                    }

                    var $selectedRow = $('.k-grid-edit-row');
                    if (!$selectedRow.length) {
                        return;
                    }

                    if ($target.closest('.k-calendar-table.k-year').length) return; // fix issue with close datepicker on month click
                    
                    // looks like k-grid-content-locked is grouping and we deny edit of such cells
                    //commented for now
                    //if (!$target.closest('.k-grid-content-locked').length || !$target.closest('.k-grid-content').length) {
                    //  self.CloseCell($selectedRow);
                    //}

                    // !$target.closest('.k-grid-content-locked').length removed but previous commenting leads to bug #2579, so this functional returned
                    var $grid = $selectedRow.first().closest('.k-grid');

                    if (!$target.closest('.k-grid-content').length
                        && $target[0].isConnected
                        && !$target.closest('.k-datetime-calendar-wrap').length) {
                        XPortal.GridInlineEditing.RemoveRowEditAttributes($grid);
                        $grid.data("kendoGrid").closeCell();                        
                    } else if ($target.closest('.k-grid-content').length) {
                        XPortal.GridInlineEditing.RemoveRowEditAttributes($grid);
                    }
                });
                
            }
        },
        SendMail: function (grid, button, activerows) {
            var gridInfo = XPortal.Grid.GetGridInfo(grid);
            var kgrid = grid.data("kendoGrid");
            var rowsForEmail = XPortal.GridActions.GetActiveRows(gridInfo, true);
            if (rowsForEmail.length === 0) return false;
            var rowUidList = [];
            var contentData = { entityAlias: grid.attr("entityalias"), emailAddr: "" };

            $.each(rowsForEmail, function (ixrs, rs) {
                rs = rs.length && rs.length > 0 ? rs : [rs];
                $.each(rs, function (ixr, r) {//-process locked & other cells
                    var uid = $(r).attr("data-uid");
                    uid = uid ? uid : r.dataset ? r.dataset.uid : "";
                    var row = rowUidList.find(uidRow => uidRow.uid === uid);
                    if (!row) {
                        row = { uid: uid, cells: [] };
                        rowUidList.push(row);
                    }
                    $.each($(r).find("td:not(.k-group-cell)"), function (ixc, xc) {
                        row.cells.push($(xc).text());
                    });
                });
            });
            var strAll = "";
            var model = self.GetViewModelByUid(grid, [rowUidList[0].uid]);
            row = rowUidList[0];
            var columns = kgrid.columns;
            row.cells.forEach(function (cellText, index) {
                if (cellText && cellText.length > 0 && !columns[index].columnMenu) {
                    strAll += columns[index].title + " : " + cellText + "<br>";
                    contentData[columns[index].field] = cellText;
                }
            });
            var mfHtml = $(button).find(".sendMailTemplate").html();
            const nodeId = kgrid.element.attr("data-id");

            contentData.editLink = !kgrid.options.pageData.details.url ? window.location.href : window.location.href.replace(window.location.pathname, "") + XPortal.EditForm.SetEditLocationUrl({ returnUrlOnly: true, grid: grid }, window.location.href);
            contentData.all = strAll;
            contentData.messageBody = XPortal.Template.TemplateToHtml(contentData, $(mfHtml).find(".xMessage").html(), nodeId)
            contentData.subject = XPortal.Template.TemplateToHtml(contentData, $(mfHtml).find(".xSubject").html(), nodeId);

            let sendMailOptions = null;
            for (key in kgrid.options.commands) {
                if (!key.startsWith('sendmail')) continue;
                sendMailOptions = kgrid.options.commands[key];
            }

            var recipientOptions = {
                modelId: model.Items[0],
                entityAlias: model.EntityAlias,
                nodeId: nodeId,
                emailSubject: contentData.subject,
                emailBody: contentData.messageBody
            };

            var options = {
                button: button,
                mailFormText: XPortal.Template.TemplateToHtml(contentData, mfHtml, recipientOptions.nodeId),
                recipientOptions: recipientOptions,
                title: $("h1").length > 0 ? $("h1")[0].innerText : sendMailOptions.title
            };

            if (sendMailOptions.silent) { //send in silent mode                    
                XPortal.Loader.show({ showOverlay: true });
                XPortal.Notificator.AjaxCall({ data: kendo.stringify(recipientOptions), url: options.button.data().maillink }, function onSuccess(element, data) {
                    XPortal.Loader.hide({ 'selector': null });
                    XPortal.EditActions.ShowSendMailResult(data, options);
                });
                return;
            }
            $.when(XPortal.EditActions.ShowMailForm(options)).then(function (xdata) {
                XPortal.EditActions.ShowSendMailResult(xdata, options);
            });
        },
        AlertUnsavedChanges: function (parameters) {
            var dfd = $.Deferred();

            XPortal.Localization.GetLocalizedStrings(
                "XFModal.Confirmations.Entity.UnSavedChanges.Title",
                "XFModal.Confirmations.Entity.GeneralUnSavedChanges",
                "XFModal.Confirmations.Entity.UnSavedChanges",
                "XFModal.Buttons.Save",
                "XFModal.Buttons.DontSave")
                .then(function (items) {
                    var header = `<i class="icon-error-warning"></i> ${items["XFModal.Confirmations.Entity.UnSavedChanges.Title"]}`;
                    var message = items["XFModal.Confirmations.Entity.GeneralUnSavedChanges"];
                    var buttonSaveChanges = items["XFModal.Buttons.Save"];
                    var buttonRejectChanges = items["XFModal.Buttons.DontSave"];
                    if ($(XPortal.Main.DetialFormSelector).length > 0) {
                        message = parameters.isNewItem && !parameters.isFormWasChanged
                            ? items["XFModal.Confirmations.Entity.UnSavedChanges"]
                            : items["XFModal.Confirmations.Entity.GeneralUnSavedChanges"];
                    }

                    parameters.options = {
                        showModal: true,
                        headerText: header,
                        confirmationText: message,
                        buttonsText: [buttonRejectChanges, buttonSaveChanges]
                    };
                    XPortal.Modal.confirm(parameters, function (result) {
                        dfd.resolve(result);
                    });
                })

            return dfd.promise();
        },
        ImportData: function (grid, button) {
            var kgrid = grid.data("kendoGrid");
            if (!XPortal.Account.Name) return XPortal.Modal.alert({ headerText: kgrid.options.messages.importdata.warningtitle, alertText: kgrid.options.messages.importdata.notloggedin });

            var options = {};
            options.importDataTemplate = $(button.parent().find(".import-data-popup-template").prop('content')).children();
            options.grid = grid;
            options.reportGridId = button.attr("data-report-gridid");
            options.maxUploadSize = button.attr("data-maxuploadsize") ? parseInt(button.attr("data-maxuploadsize")) : 0;
            options.fileTypes = button.attr("data-filetypes") ? button.attr("data-filetypes").split('|') : "";
            options.uploadUrl = button.attr("data-upload-url");
            options.processBatchUrl = button.attr("data-process-batch-url");
            options.finalizeBatchUrl = button.attr("data-finalize-batch-url");
            options.finalizeImportUrl = button.attr("data-finalize-import-url");
            options.reportUrl = button.attr("data-report-url");
            options.settings = JSON.parse(button.attr("data-settings") || "{}");
            options.texts = kgrid.options.messages.importdata;
            var gridId = grid.attr("data-id");
            var parentInfo = XPortal.Grid.dictionaryParent[gridId];
            options.parentInfo = parentInfo ? decodeURIComponent(parentInfo) : null;
            XPortal.ImportData.InitImportDataPopup(options);
        },
        ModifyRecord: function (grid, button, arow) {
            if (!XPortal.Account.Name) {
                XPortal.Modal.alert({
                    headerText: grid.data("kendoGrid").options.messages.modifyentity.warningtitle,
                    alertText: grid.data("kendoGrid").options.messages.modifyentity.notLoggedIn
                });
                return;
            }
            return XPortal.EditActions.ModifyEntity(grid, button, arow);
        },
        ComplexDelete: function (grid, button, arows, where) {
            if (!XPortal.Account.Name) {
                XPortal.Modal.alert({
                    headerText: grid.data("kendoGrid").options.messages.complexdelete.warningtitle,
                    alertText: grid.data("kendoGrid").options.messages.complexdelete.notLoggedIn
                });
                return;
            }
            return XPortal.EditActions.ComplexDeleteItems(grid, button, arows, where);
        },
        UpdateSelectAllCheckbox: function ($grid, isDeleteAction) {
            const gridId = $grid.attr("data-id");
            const trows = $grid.find("table tr");
            const trowsCount = $grid.data("kendoGrid").dataSource._data.length;
            const gridSelectActOpts = self.actionmodels[gridId].selectActOpts;
            const checkedCount = trows.find(".service .state-checked:not(.d-none)").length / 2;
            const uncheckedCount = trows.find(".service .state-checked").length / 2;

            if (checkedCount && checkedCount == trowsCount) gridSelectActOpts.set("allSelected", true);
            else gridSelectActOpts.set("allSelected", false);
            if (isDeleteAction && checkedCount == uncheckedCount) gridSelectActOpts.set("allSelected", false);
        }
    };
    function setGridContentView(grid) {
        var ginfo = XPortal.Grid.GetGridInfo(grid);
        let btn = getFirstContentViewAction(ginfo, false);
        if (btn && btn.attr("data-cvkey") != "b2grid") btn = null;
        return btn ? self.ChangeContentView(ginfo.grid, btn) : null;
    };
    function getServiceColumn(fieldName, data, gridInfo, gridsettings) {
        const $tmplSrc = gridInfo.parent.find(".serviceColumnTemplate");
        const tmplt = $("<div></div>").append($tmplSrc.html());
        kendo.bind(tmplt, data);
        const tmpl = tmplt.html();
        return {
            title: $tmplSrc.attr("data-col-title") || "Service",
            headerTemplate: function () {
                var tmodel = self.actionmodels[gridsettings.pageData.nodeId];
                if (tmodel) {
                    clearTimeout(data.serviceColHeaderTemplateTimeout);
                    data.serviceColHeaderTemplateTimeout = setTimeout(function () { tmodel.set("updatedAt", new Date()); }, 300);
                }
                return kendo.template(gridInfo.parent.find(".serviceHeaderTemplate").html() || "")(data);
            },
            field: fieldName,
            locked: data.hasLockedColumns != null,
            lockable: false,
            sortable: false,
            columnMenu: true,
            filterable: false,
            groupable: false,
            template: tmpl,
            width: data.width ? data.width : 0,
            attributes: { "class": "service" }
        };
    }

    function СopyTextToClipboard(text) {
        var textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.id = "textareaforclipboard";

        // Avoid scrolling to bottom
        textArea.style.top = "0";
        textArea.style.left = "0";
        textArea.style.position = "fixed";

        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            console.log('Fallback: Copying text command was ' + msg);
        } catch (err) {
            console.error('Fallback: Oops, unable to copy', err);
        }

        document.body.removeChild(textArea);
    }
    function InitContextMenu(rights, settings, gridInfo) {
        var source = { data: {}, cmrights: [] };
        var menu = $('<ul class="gridCtxMenu" data-bind="source: cmrights" data-template="contextMenuTemplate"></ul>');
        source.cmrights = _.sortBy(rights.filter(r => r.isContextMenuOnly || r.isIndividual), function (x, ix) { return x.commandName === "filter" ? -1 : (x.commandName === "select" ? 999998 : x.commandName === "copy" ? 999999 : ix); });

        kendo.bind(menu, source);
        var select = function (e) {
            var cell = $(e.target);
            var ctype = cell.attr("data-ctype") || '';
            var action = $(e.item).attr("data-action");
            var currentObj = XPortal.Grid.GetGridDataRowItem(gridInfo, cell, gridInfo.grid);
            var cfield = XPortal.Template.GetObjPropName(currentObj, cell.attr("data-cfield"));
            var rowAction = XPortal.Grid.GetRowAction(gridInfo, action, cell);
            if (action === "Filter") {
                var kgrid = gridInfo.kgrid;
                if (currentObj && currentObj.hasOwnProperty(cfield)) {
                    var dataValue = currentObj[cfield];
                    if (ctype === "boolean") dataValue = dataValue ? "1" : 0;
                    let groupFilter = XPortal.GridFiltering.CreateFilter({ field: "___group___", operator: "eq", value: "___group___", logic: "And" }, kgrid);
                    let fieldFilter = XPortal.GridFiltering.CreateFilter({ field: cfield, operator: dataValue === null || dataValue === "" ? "blank" : "eq", value: dataValue, logic: "And" }, kgrid);
                    let resultFilters = [groupFilter, fieldFilter];
                    let gridId = kgrid.options.pageData.nodeId;
                    XPortal.Grid.SetFilters(resultFilters, kgrid.dataSource);
                    if (gridId) XPortal.GridActions.actionmodels[gridId].set("filtered", true);
                }
            }
            else if (action === "Copy") {
                if (currentObj && currentObj.hasOwnProperty(cfield)) {
                    let dataValue;
                    let fieldValue = currentObj[cfield];
                    let cellValue = (cell.find(".tdcell").first().text() || "").trim();
                    if (ctype.indexOf("date") > 0) dataValue = cellValue;
                    else {
                        if (cellValue && cellValue != fieldValue) dataValue = cellValue;
                        else dataValue = fieldValue;
                    }
                    СopyTextToClipboard(dataValue);
                }
            }
            else {
                if (rowAction.length > 0) {
                    if (rowAction.length == 1) return rowAction.trigger("click");
                    actionuid = $(e.item).attr("data-action-uid");
                    rowAction = rowAction.filter(function (ix, x) {
                        return $(x).attr("data-action-uid") == actionuid || $(x).closest("li").attr("data-uniqueid") == actionuid;
                    });
                    if (rowAction.length > 0) return $(rowAction[0]).trigger("click");
                    if (console && console.warn) console.warn("can't find tool bar actgion t o process context menu");
                }
                else {
                    var activerow = self.GetCurSelectedRow(gridInfo, cell);
                    var optionsButton = XPortal.Grid.GetGridOptionButton(gridInfo, $(e.item));
                    self.ProcessActionToolbar(gridInfo.grid, action, optionsButton, activerow, "row", currentObj);
                }
            }
        };
        var open = function (e) {
            var cell = $(e.target);
            var cmenu = $(e.sender.element);
            var celltext = cell.text() ? cell.text().trim() : '';
            var ctype = cell.attr("data-ctype") || '';
            var cfield = cell.attr("data-cfield");
            source.data = XPortal.Grid.GetGridDataRowItem(gridInfo, cell, gridInfo.grid) || {};
            transformMenuItemsTemplate(cmenu, source.data);

            var delAction = cmenu.find("li[data-action = 'Delete']");
            if (delAction.length !== 0) {
                var ownersOnly = delAction.find(".dropdown-menu-link").attr("data-owners-only") === "1";
                if (!ownersOnly || source.data.IsOwnRecord) delAction.removeClass("d-none"); else delAction.addClass("d-none");
            }

            var filterEl = cmenu.find("li[data-action = 'Filter']");
            if (filterEl.length > 0) {
                if (ctype === "boolean") {
                    if (source.data && source.data.hasOwnProperty(cfield) && ctype === "boolean") {
                        var dataValue = source.data[cfield];
                        celltext = dataValue === true ? "True" : "False";
                    }
                }

                var filterText = XPortal.Utils.formatString(settings.extendedOptions.contextMenuFilterBy, {
                    regex: /\[value\]/,
                    text: celltext === "" ? self.emptyValueText : celltext
                });
                filterEl.find(".dm-item-text").text(filterText);
            }
        }
        menu.clone().kendoContextMenu({ orientation: "vertical", target: "#" + gridInfo.list.attr("id"), filter: ".entity-cvfld", select, open });
        menu.kendoContextMenu({ orientation: "vertical", target: "#" + gridInfo.grid.attr("id"), filter: "td[data-cfield]", select, open });
    }
    function transformMenuItemsTemplate(menu, selRowData) {
        menu.find("li").each(function (lix, lx) {
            var lx$ = $(lx);
            var lxh = lx$.data("k-template");
            if (!lxh) lxh = $("<div></div>").append(lx$.clone()).html() || "";
            if (lxh.indexOf("#=") < 0) return;

            lx$.data("k-template", lxh);
            lxh = $(kendo.template(lxh)(selRowData));

            lx$.html(lxh.html());
            var sattr = lxh.prop("attributes") || [];
            for (var i = 0; i < sattr.length; i++) {
                let lxhn = sattr[i].name;
                let lxhv = lxh.attr(lxhn);
                if (lxhn && lxhv && lx$.attr(lxhn) != lxhv)
                    lx$.attr(lxhn, lxhv);
            }
        });
    }
    function onNavigateToError(e) {
        e.preventDefault();

        var currentServiceRow = $(e.currentTarget).closest("tr");
        var uid = currentServiceRow.attr("data-uid");

        var grid = $(e.currentTarget).closest(".grid-parent").find(".k-grid");
        var currentContentRow = grid.find(".k-grid-content tr[data-uid='" + uid + "']");
        var firstCellWithError = currentContentRow.find('td.not-valid-cell:first');
        if (firstCellWithError && firstCellWithError.length > 0) {
            if (!$(document.activeElement).hasClass("k-selectable")) {
                if (firstCellWithError.parents(".k-selectable").length > 0) {
                    var targetTable = firstCellWithError.parents(".k-selectable")[0];
                    if (typeof targetTable.tabIndex === typeof undefined) {
                        targetTable.tabIndex = -1;
                    }
                    targetTable.focus();
                }
            }

            var kgrid = $(grid).data("kendoGrid");
            kgrid.current(firstCellWithError);
            if (firstCellWithError.attr("data-ctype") !== "boolean") {
                kgrid.editCell(firstCellWithError[0]);
            }
        }
    }

    function onRemoveRecord(e) {
        var currentRow = $(e.currentTarget).closest("tr");
        var grid = $(e.currentTarget).closest(".grid-parent").find(".k-grid");
        var call = $(e.currentTarget).attr("data-deleteRecords");
        XPortal.GridActions.DeleteRecords([grid.data("kendoGrid").dataItem(currentRow)], grid, call);
    }

    function getfileNameforExport(griddata, ext, opts) {
        const fName = opts && opts.gridTitle ? opts.gridTitle : "Grid";
        let result = fName;
        if (!opts || !opts.gridTitle) {
            const parent = griddata.element.closest(".grid-parent");
            if (parent.length > 0) {
                let $title = $(parent).find('.entity-grid');
                const original = $title.attr('data-file-title') ? $title.attr('data-file-title') : "";
                $title = parent.find(".original-title");
                const viewtitle = $title.attr('data-current-title') ? $title.attr('data-current-title') : "";
                result = (original.length > 0 ? original : fName) + (viewtitle.length > 0 ? "-" + viewtitle : "");
            }
        }
        if (!result || !result.length) result = fName + ext;
        if (ext) result = result.toLowerCase().indexOf(ext.toLowerCase()) > 0 ? result : result + ext;
        return result;
    }

    function GetURLParameter(urlstring, sParam) {

        urlstring = urlstring.split('?')[1];
        var sURLVariables = urlstring.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] === sParam) {
                return sParameterName[1];
            }
        }
    }
    function GetCheckedRowUidList(grid) {
        var griddata = grid.data("kendoGrid");
        var selectedrows = XPortal.GridActions.GetXSelectedRows(grid);
        var objects = [], ids = [];
        _.each(selectedrows, function (row) {
            var o = griddata.dataItem(row);
            if (o != undefined) {
                var id = o.UniqueId === null ? o.uniqueid : o.UniqueId;
                if (!ids.includes(id)) {
                    ids.push(id);
                    objects.push(o);
                }
            }
        });
        return objects;
    }
    function getSelectedObjects(grid, setCheck, rowstoprocess) {
        var gridInfo = XPortal.Grid.GetGridInfo(grid);
        var selectedrows = rowstoprocess ? rowstoprocess : XPortal.GridActions.GetActiveRows(gridInfo, setCheck);
        var objects = [], ids = [];
        _.each(selectedrows, function (row) {
            var o = gridInfo.kgrid.dataItem(row);
            if (o != undefined) {
                var id = o.UniqueId === null ? o.uniqueid : o.UniqueId;
                if (!ids.includes(id)) {
                    ids.push(id);
                    objects.push(o);
                }
            }
        });
        return objects;
    }

    function dataSource_change(e) {
        self.updateActionStates(e.sender);
    };
    function updateActionStates(e) {
        self.updateActionStates(e.sender);
    };
    function SetSessionFilters(modelId, kgrid) {
        var model = XPortal.GridSettings.models[modelId];
        if (!model) return;
        var filter = kgrid.dataSource.filter();
        var locations = [window.location.href + modelId + "_" + XPortal.Account.Name];
        if (model.current) {
            if (window.location.hash === "" && model.current.linkUrl !== "") {
                locations.push(window.location.href + model.current.linkUrl + modelId + "_" + XPortal.Account.Name);
            }
            else if (window.location.hash !== "" && model.current.linkUrl.indexOf("/v/" + XPortal.GridSettings.Normalize(XPortal.GridSettings.DefViewTitle)) > -1) {
                locations.push(window.location.href.replace(window.location.hash, "") + modelId + "_" + XPortal.Account.Name);
            }
        }
        filter = (!filter || filter.filters.length === 0) ? { filters: [] } : filter;
        locations.forEach(l => {
            sessionStorage.setItem(l, JSON.stringify(filter));
        });
    }


    function toolBarSpinner(element, show, showOverlay) {
        return show ? XPortal.Loader.show({ 'selector': element, showOverlay: !(!showOverlay) }) : XPortal.Loader.hide({ 'selector': element, showOverlay: !(!showOverlay) });
    }
    function toolBarSpinnerMessage(element, text, ttip, showOverlay) {
        return XPortal.Loader.message({ 'selector': element, showOverlay: !(!showOverlay) }, text, ttip);
    }
    function checkExportActivity(button) {
        let isTrackExport = button.attr("data-track-export");
        let activityType = button.attr("data-track-export-type");
        if (isTrackExport == 1) XPortal.ActivityLoger.TrackExport(activityType);
    }

    function getIndividualCommands(gridInfo, settings) {
        var rights = [/*predefined commands*/
            { id: "selectionEnabled", value: true, commandName: "select", actionHtml: "<span class='row-checkbox #= addCss #' data-action='#= action #'><span class='d-none state-checked'>#= checkedIcon #</span><span class='state-unchecked'>#= uncheckedIcon #</span></span><label class='k-checkbox-label dm-item-text'>#= title#</label>", addCss: "d-none", action: "", checkedIcon: "", uncheckedIcon: "", title: "" },
            { id: "editable", value: false, commandName: "edit" },
            { id: "deletable", value: false, commandName: "delete", icon: '<i class="icon-delete-bin-4"></i>' },
            {
                id: "notification", value: false, commandName: "notificationsubscription",
                actionAttrs: "data-refreshicons=\"#= XPortal.Template.ReplaceFormatString('[[UniqueId]]','',data," + gridInfo.nodeId + ")#\"",
                actionHtml: "<span class='#= data.isActiveCss(true, data) #'>#= data.icon? data.icon : '' #<span class=\"dm-item-text\">#= data.addtitle #</span></span><span class='#= data.isActiveCss(false, data) #'>#= data.remicon?data.remicon:'' #<span class=\"dm-item-text\">#= data.remtitle #</span></span>",
                isActiveCss: function (foractive, idata) {
                    return "#= XPortal.GridActions.IsDNotifOn(" + gridInfo.nodeId + ", data," + foractive + ") #";
                },
                getTitle: function () {
                    let remtitle = this.remtitle || "";
                    let addtitle = this.addtitle || "";
                    remtitle = !remtitle.indexOf("'") ? remtitle : remtitle.replace("'", "\\'");
                    addtitle = !addtitle.indexOf("'") ? addtitle : addtitle.replace("'", "\\'");
                    return "#= (XPortal.GridActions.IsDNotifOn(" + gridInfo.nodeId + ", data," + true + ")||'').indexOf('d-none') >= 0 ? '" + remtitle + "' : '" + addtitle + "' #";
                },
            },
            { id: "filterable", value: false, commandName: "filter" },
            { id: "compare", value: false, commandName: "compare" },
            { id: "copy", value: false, commandName: "copy", action: "Copy", isContextMenuOnly: true, isIndividual: false, title: settings.extendedOptions.contextMenuCopy, icon: '<i class="icon-file-copy"></i>' },
            { id: "complexDeletable", value: false, commandName: 'complexdelete', title: settings.extendedOptions.contextMenuComplexDelete, action: 'ComplexDelete', icon: '' },
        ];
        var hasrights = false;
        var selectableWidth = 28;
        rights.forEach(function (right) {
            if (right.commandName === "edit" && (!((settings.pageData || {}).details || {}).url)) return console.warn("can't register individual command, there is no detail page");
            if (settings.commands.hasOwnProperty(right.commandName) && (settings.commands[right.commandName].isIndividual || settings.commands[right.commandName].isContextMenuOnly)) {
                right = _.extendOwn(right, settings.commands[right.commandName]);
                right.value = settings.commands[right.commandName].isIndividual;
                right.title = right.title ? right.title : ""
                hasrights = true;
                if (right.commandName === "select") {
                    right.addCss = right.value ? "" : "d-none";
                    right.value = true;
                }
            }
            if (!right.getTitle) right.getTitle = () => right.title;
            if (right.actionHtml) right.actionHtml = kendo.template(right.actionHtml)(right);
        });
        for (var cmd in settings.commands) {
            if (settings.commands[cmd].isIndividual) {/*add other dynamic commands*/
                if (rights.find(ri => ri.commandName === cmd) == null) {
                    let right = _.extendOwn({ id: cmd, value: true, commandName: cmd }, settings.commands[cmd]);
                    right.title = right.title ? right.title : "";
                    if (!right.getTitle) right.getTitle = () => right.title;
                    rights.push(right);
                }
                hasrights = true;
            }
        }
        if (!hasrights) return rights;
        if (settings.columns.length === 0) return rights;
        let hasLockedColumns = _.find(settings.columns, function (col) { return col.locked === true; });
        var filteredRights = rights.filter(ri => ri.value);
        settings.columns.unshift(
            getServiceColumn(
                "selectable",
                {
                    pagedata: settings.pageData,
                    rights: filteredRights,
                    hasLockedColumns: hasLockedColumns,
                    width: selectableWidth +
                        (!settings.compactMode
                            ? filteredRights.length * 24
                            : (rights.filter(ri => ri.value && ri.commandName === 'select').length
                                ? 20 + (filteredRights.length > 0 ? 20 : 0)
                                : filteredRights.length > 0 ? 20 : 0
                            )
                        )
                },
                gridInfo, settings
            )
        );
        return settings.commandsIndividual = rights;
    };
    function updateRowSelectionState(gridInfo, rows, setCheckForSelected, setUnCheckForSelected, makeSelection) {
        if (!rows || rows.length < 1) return rows;
        if (setUnCheckForSelected) {
            rows.last("tr").removeClass("k-state-selected");
        }
        if (makeSelection && setCheckForSelected && rows.last("tr").length) {
            gridInfo.kgrid.select(rows.last("tr"));
        }
        rows.find(".service .row-checkbox").each(function () {
            const el = $(this);
            if (setCheckForSelected)
                addRemoveCssTo(el.find(".state-unchecked"), el.find(".state-checked"), "d-none");
            if (setUnCheckForSelected)
                addRemoveCssTo(el.find(".state-checked"), el.find(".state-unchecked"), "d-none");
        });
        saveGridSelection(gridInfo);
        return rows;
    }
    function saveGridSelection(gridInfo) {
        if (!gridInfo || !gridInfo.grid) return;
        const current = gridInfo.grid.data("lastCheckedRows");
        const newids = getSelectedUniqieIds(gridInfo);
        const alreadySel = _.intersection(current, newids);
        const toAdd = _.difference(newids, alreadySel);
        const result = _.union(alreadySel, toAdd);
        gridInfo.grid.data("lastCheckedRows", result);
    };
    function getSelectedUniqieIds(gridInfo) {
        let uIds = [];
        let result = [];
        self.GetXSelectedRows(gridInfo.grid, false, uIds);
        _.uniq(uIds).forEach(function (x) {
            var dobj = gridInfo.kgrid.dataSource.data().find(function (ei) { return XPortal.Template.GetObjPropValueByName(ei, "uid") == x; });
            result.push(XPortal.Template.GetObjPropValueByName(dobj, "uniqueid"));
        });
        return result;
    };
    function restoreGridSelection(gridInfo) {
        if (!gridInfo || !gridInfo.grid) return;
        var uniqueIds = gridInfo.grid.data("lastCheckedRows") || [];
        return restoreSelectionImmediatelly(gridInfo, uniqueIds);
    };
    function restoreSelectionImmediatelly(gridInfo, idstosel, applySelection) {
        if (!gridInfo || !gridInfo.grid) return;
        var uniqueIds = (idstosel || gridInfo.grid.data("lastCheckedRows")) || [];
        var rowsToSelect = [];
        var selectedids = [];
        var curselected = [];
        _.each(self.GetXSelectedRows(gridInfo.grid, true), xii => curselected.push({ d: xii, o: getSelectedObjects(gridInfo.grid, false, [xii]) }));

        uniqueIds.forEach(function (x) {
            _.each(XPortal.Grid.GetGridRowsByUniqueId(gridInfo.grid, x, true, selectedids), function (ri) {
                _.each(ri, xii => {
                    const xiit = getSelectedObjects(gridInfo.grid, false, [xii]);
                    var alreadySel = curselected.find(csel => csel.o == xii);
                    if (!alreadySel) rowsToSelect.push({ d: xii, o: xiit });
                });
            });
        });
        curselected.forEach(i => {
            if (!uniqueIds.find(uid => i.o.UniqueId == uid))
                updateRowSelectionState(gridInfo, $(i.d), false, true, applySelection);
        });

        _.each(rowsToSelect, function (x) {
            updateRowSelectionState(gridInfo, $(x.d), true, false, applySelection);
        });

        return restoreViewSelection(gridInfo, uniqueIds, true);
    };
    function ensureGroupTemplate(ginfo, itemSrcTemplate) {
        if (!(((ginfo || {}).kgrid || {}).options || {}).groupable) return itemSrcTemplate;
        var itemTemplate = kendo.template(itemSrcTemplate);
        var groupItmTmpl = self.lviewGroupItmTmpl || (self.lviewGroupItmTmpl = kendo.template('<div class="col-12"><div class="row m-0 p-0 d-flex"><div class="col-12">#= header #</div></div><div class="row">#= titems #</div></div>'));
        var subGgrpHTmpl = self.lviewGroupHdrTmpl || (self.lviewGroupHdrTmpl = kendo.template('<span class="#= \'gh-\'+level #"><span class="gh-field" style="font-weight:bold;text-transform:uppercase;">#= field #&nbsp;</span><span class="gh-value">#= value #&nbsp;</span></span>'));
        var gresult = function (ditem, isSubLevel, level) {
            var ditem = ditem || {};
            ditem.items = ditem.items || [];
            ditem.level = level || 0;
            ditem.value = (ditem.value || "").split("_#_").join(",");
            ensurePropsValues(ditem);

            if (!(ditem.hasOwnProperty("field") && ditem.hasOwnProperty("value") && ditem.hasOwnProperty("items"))) return itemTemplate(ditem);
            var titems = ditem.hasSubgroups
                ? ditem.items.map(di => gresult(di, true, level > 0 ? level + 1 : 1))
                : ditem.items.map(di => itemTemplate(di));

            ditem.header = subGgrpHTmpl(ditem) + (ditem.hasSubgroups ? ditem.items.map(di => di.header).join("") : "");
            ditem.titems = titems.join("");
            return isSubLevel ? ditem.titems : groupItmTmpl(ditem);
        };
        return gresult;
    }

    function ensurePropsValues(ditem) {
        const nullValueProps = Object.keys(ditem)
            .filter(key => ditem[key] === null)
            .map(key => key.toLowerCase());

        ditem.Fields.forEach(field => {
            const fieldNameLower = field.Name.toLowerCase();
            if (nullValueProps.includes(fieldNameLower)) {
                ditem[Object.keys(ditem).find(key => key.toLowerCase() === fieldNameLower)] = field.StringValue;
            }
        });
    };
    
    function initListViewTooltip(gridInfo) {
        if (gridInfo && gridInfo.list) {
            gridInfo.list.kendoTooltip({
                show: function () {
                    this.popup.element.addClass("grid-tooltip");
                },
                filter: ".entity-fld-val, .entity-cvfld:has('.edit-tags')",
                position: "top",
                width: 200,
                showAfter: 1500,
                content: function (e) {
                    let $target = $(e.target);
                    const hasFRTooltip = $target.find("a.tooltip.fr-tooltip").length;
                    if (hasFRTooltip) return "";
                    if ($target.has(".tags-format-container").length) {
                        let tagsStr = $target.find(".edit-tags").data("tags");
                        let tags = tagsStr.split('_#_') || [];
                        if (!tagsStr && !tagsStr.length <= 1)
                            return XPortal.Localization.GetLocalizedStrings("XFModal.Error.Title");
                        var template = kendo.template($("#tagsTooltip").html());
                        return template(tags);
                    }
                    return $.trim(e.target.html());
                }
            });
        }
    };
    function restoreViewSelection(gridInfo, uniqueIds, toCheck) {
        if (gridInfo && gridInfo.grid && gridInfo.list) {
            let lItemSel = ".entity-cvitem";
            let uIds = uniqueIds && uniqueIds.concat(getSelectedUniqieIds(gridInfo)) || getSelectedUniqieIds(gridInfo);
            gridInfo.list.find(lItemSel).each(function () {
                let li = $(this);
                var uid = li.attr("data-u-uid");
                var eli = uIds.find(function (x) { return x == uid; });
                var checkBox = li.find('input[type="checkbox"]');
                if (eli) {
                    li.addClass("k-state-selected").addClass("li-state-selected");
                    toCheck && checkBox && checkBox.prop("checked", true);
                } else {
                    li.removeClass("k-state-selected").removeClass("li-state-selected");
                    checkBox && checkBox.prop("checked", false);
                }
            });
        }
    };
    function isActionContentViewVisible(ginfo, button) {
        var ckey = button.attr("data-cvkey");

        var listShowsAlready = ginfo.list.attr("data-cvkey") == ckey;
        ginfo.list.attr("data-cvkey", ckey);
        if (ckey == "b2grid")
            addRemoveCssTo(ginfo.list, ginfo.grid, "entity-grid-hidden");
        else
            addRemoveCssTo(ginfo.grid, ginfo.list, "entity-grid-hidden");
        listShowsAlready = ckey == "b2grid" || listShowsAlready;

        var btns = ginfo.parent.find("*[data-action='" + button.attr("data-action") + "']");
        btns.each(function () {
            if ($(this).attr("data-cvkey") == ckey)
                addRemoveCssTo($(this), null, "inactive");
            else
                addRemoveCssTo(null, $(this), "inactive");
        });
        ginfo.kgrid.dataSource.isListView = !listShowsAlready;
        return !listShowsAlready;
    };
    function getFirstContentViewAction(ginfo, excludingGrid) {
        var btnsCntr = ginfo.actionsHeader;
        if (btnsCntr.left < 1) return null;
        var ris = $(btnsCntr[0]).find("*[data-action='ChangeContentView']");
        var res = ris.length > 0 ? $(ris[0]) : null;
        if (res && res.attr("data-cvkey") == "b2grid") {
            if (excludingGrid) return ris.length > 1 ? $(ris[1]) : res;
        }
        return res;
    };
    function getContentViewAction(ginfo, ckey) {
        var btnsCntr = ginfo.actionsHeader;
        if (btnsCntr.left < 1 || !ckey) return null;
        var ris = $(btnsCntr[0]).find("*[data-action='ChangeContentView']");
        var res = null;
        ris.each(function (belix, bel) {
            if ($(bel).attr("data-cvkey") == ckey)
                res = $(bel);
        });
        return res;
    };
    function initExportTo(gridInfo, button, activerows, exportAction, ext) {
        var kgrid = gridInfo.kgrid;
        var items = getSelectedObjects(gridInfo.grid, true, activerows);
        ext = ext ? ext : ".xlsx";
        var pgbl = kgrid.options && kgrid.options.pageable && kgrid.options.pageable.pageSizes ? kgrid.options.pageable.pageSizes : [20];
        var minPsize = Math.min(...(pgbl.map(x => Number(x)).filter(x => x > 0))) || 20;
        if (!(Number(kgrid.dataSource.pageSize()) > 0)) kgrid.dataSource.pageSize(minPsize);
        var exportOptions = {
            columns: kgrid.columns, dataSource: kgrid.dataSource, allPages: false, filterable: true, hierarchy: false,
            pageIndex: kgrid.dataSource.page(), pageSize: kgrid.dataSource.pageSize(), pagesAmount: kgrid.dataSource.totalPages(), joinPages: true,
            selUids: getSelectedUniqieIds(gridInfo),
            message: function (p, mp) {
                var diffsec = (new Date() - exportOptions.dstart) / 1000;
                var percComplete = (p / mp) * 100;
                var secleft = Math.max((100 * diffsec) / percComplete - diffsec, 0);
                var tLeft = secleft > 60 ? '~' + Math.ceil(secleft / 60) + 'min' : '~' + Math.ceil(secleft / 60) + 'sec';
                var ttip = '' + Math.ceil(percComplete) + '% complete\r\ntime left:' + tLeft;
                toolBarSpinnerMessage(null, '' + Math.ceil(percComplete) + '%', ttip, true);
                return diffsec;
            }
        };
        var total = kgrid.dataSource.total();
        var pgSize = exportOptions.pageSize = exportOptions.pageSize || kgrid.dataSource.options.pageSize;

        if (!exportOptions.pageSize)
            exportOptions.pagesAmount = Math.floor(total / pgSize) + (total % pgSize > 0 ? 1 : 0);
        else {
            if (items.length) exportOptions.pagesAmount = 0;
        }
        var popupObj = $('#gridActionsModalBox');
        var popupOpts = XPortal.EditActions.InitGenericPopupOptions(popupObj, button, '.export-to-popupcontainer', '.export-to-container');
        var gridTitle = getfileNameforExport(gridInfo.kgrid, ext, popupOpts);

        var executeMainLogic = function () {
            checkExportActivity(button);
            exportOptions.dstart = new Date();
            if (items.length == 0) {
                kgrid.dataSource.page(exportOptions.pageIndex = 0);
            } else
                exportOptions.selection = items;

            exportOptions.gridTitle = startStep ? startStep.find(".export-file-name").val() : gridTitle;
            if (!exportOptions.gridTitle || !exportOptions.gridTitle.length)
                exportOptions.gridTitle = popupOpts.gridTitle;
            XPortal.Modal.hideModal(popupObj, function () { });
            exportAction(exportOptions, items.length == 0, kgrid);
        };
        var startStep = null;
        if (popupOpts.showConfirmation || items.length === 0) {
            const stepselection = items.length ? ".selection" : ".noselection";
            popupOpts.messages.confirmationBody = items.length ? popupOpts.confirm.options.confirmationText : popupOpts.confirm.options.confirmationTextNoSEl;
            popupObj = XPortal.EditActions.initModalPopup(popupObj, popupOpts, function () {
                startStep = popupObj.find(stepselection);
                var nsel = startStep.find(".intro");

                nsel.html(XPortal.EditActions.TransformPopupTemplate(items, popupOpts, items.length ? items.length : total));

                popupObj.find(".export-file-name").val(gridTitle);
                popupOpts.showStep(stepselection, null, popupObj);
            }, null, function (e) { });
            popupObj.on("click", "button", function (e) {
                var el = $(this);
                if (el.hasClass("export-btn")) {
                    executeMainLogic(true);
                }
            });
        } else {
            exportOptions.gridTitle = gridTitle;
            executeMainLogic();
        }
    };
    function addRemoveCssTo(addEl, remEl, className) {
        if (addEl) addEl.addClass(className);
        if (remEl) remEl.removeClass(className);
    };

    function submitDynamicForm(action, fields, frmMethod, frmTarget, frmIsMultipart) {
        frmMethod = frmMethod || "post";
        frmTarget = frmTarget || "_self";

        const frm = $(".dynamic-form");
        const form = frm[0];

        form.setAttribute("method", frmMethod);
        form.setAttribute("action", action);
        form.setAttribute("target", frmTarget);
        if (frmIsMultipart) form.enctype = "multipart/form-data";
        else frm.removeAttr("enctype");
        form._submit_function_ = form.submit;
        const cntr = frm.find(".dynamic-data");
        cntr.html("");
        let hiddenField = null;
        for (var fkey in fields) {
            if (fields.hasOwnProperty(fkey)) {
                const value = fields[fkey];
                const key = fkey;
                if (Array.isArray(value)) {
                    let i = 0;
                    value.forEach((item) => {
                        const keyi = key + "[" + (i++) + "]";
                        hiddenField = document.createElement("input");
                        hiddenField.setAttribute("type", "hidden");
                        hiddenField.setAttribute("name", keyi);
                        hiddenField.setAttribute("value", item);

                        $(hiddenField).appendTo(cntr);
                    });
                }
                else {
                    hiddenField = document.createElement("input");
                    hiddenField.setAttribute("type", "hidden");
                    hiddenField.setAttribute("name", key);
                    hiddenField.setAttribute("value", value);

                    $(hiddenField).appendTo(cntr);
                }
            }
        }
        try {
            form._submit_function_();
        } catch (ex) {
            if (console && console.log) console.log(ex);
        }

    };
    function initCopyPastRecord(gridInfo) {
        $(document).ready(function () {
            var ctrlDown = false, ctrlKey = 17, cmdKey = 91, vKey = 86, cKey = 67;
            $(document).keydown(function (e) {
                ctrlDown = (e.keyCode == ctrlKey || e.keyCode == cmdKey);
            }).keyup(function (e) {
                ctrlDown = !(e.keyCode == ctrlKey || e.keyCode == cmdKey);
            });
            $(gridInfo.grid).keydown(function (e) {
                if (ctrlDown && (e.keyCode == cKey))
                    executeCopySelectedLines(gridInfo);
                if (ctrlDown && (e.keyCode == vKey))
                    executePastSelectedLines(gridInfo);
            });
        });
    };
    function executeCopySelectedLines(gridInfo) {
        return;
        const rows = XPortal.GridActions.GetActiveRows(gridInfo, false);
        const items = getSelectedObjects(gridInfo.grid, false, rows);
        let acRowArr = [];
        _.each(items, function (xx, xi) {
            if (!xx) return;
            let itemObj = gridInfo.kgrid.columns
                .map(function (x) { return { "name": x.field, "value": xx[x.field] }; });
            if (itemObj) acRowArr.push(itemObj);
        });
        acRowArr = acRowArr.reverse();
        localStorage.setItem('portal-copy-past', JSON.stringify(acRowArr));
    };
    function executePastSelectedLines(gridInfo) {
        return;
        const editMode = (XPortal.GridInlineEditing.GetEditMode(gridInfo.grid) || "").toLowerCase();
        if (editMode != 'grid-inline' && editMode != 'grid-detail') return console.log("---copy-past: edit mode is disable");
        let arowsStr = localStorage.getItem('portal-copy-past', "");
        let activerows = arowsStr && arowsStr.length ? JSON.parse(arowsStr) : [];
        if (!activerows || !activerows.length) return console.log("---copy-past: there is no data to past");

        var selectedrows = getSelectedObjects(gridInfo.grid, false, XPortal.GridActions.GetActiveRows(gridInfo, false));
        if (!selectedrows || !selectedrows.length) return console.log("---copy-past: there is no selected rows to past data over them");
        console.log("---copy-past: There " + activerows.length + " rows to past, over: " + selectedrows.length, { src: activerows, dst: selectedrows });
        let ids = [];
        let modelName = gridInfo.modelName;
        let model = XPortal.Store.GetModelByName(modelName);
        let gridCols = gridInfo.kgrid.columns.map(function (x) { return { "name": x.field }; });
        _.each(selectedrows, function (o, oi) {
            var oid = o ? XPortal.Template.GetObjPropValueByName(o, "uniqueid") : null;
            if (!oid || ids.includes(oid)) return console.log("--- " + oi + " --copy-past: grrow has been processed or empty data" + oid + "", { dst: o, grow });

            ids.push(oid);
            if (!activerows.length) return;
            var arow = activerows.pop().filter(f => Object.hasOwn(f, 'value') && gridCols.find(c => c.name.toLowerCase() == f.name.toLowerCase()));
            if (arow.length) {
                XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.BIND_ENTITY, modelName: modelName, entity: o });
                console.log("--- " + oi + " --copy-past: update row " + oid + "", { src: arow, dst: o });
                arow.forEach(x => {
                    XPortal.Store.DispatchNoAutoSave(modelName, x.name, x.value);
                });
            } else console.log("--- " + oi + " --copy-past: there is no any field to copy, different filds in src and dst  " + oid + "", { src: arow, dst: o });
        });

    };
    return self;
}());

XPortal.ExcelExporter = kendo.ExcelExporter.extend({
    init: function (options) {
        options.columns = this._trimColumns(options.columns || []);
        this.allColumns = $.map(this._leafColumns(options.columns || []), this._prepareColumn);
        this.columns = $.grep(this.allColumns, function (column) {
            return !column.hidden;
        });
        this.options = options;
        options.pageIndex = options.pageIndex > 0 ? options.pageIndex : 1;
        var dSource = options.dataSource;
        if (dSource instanceof kendo.data.DataSource) {
            this.dataSource = XPortal.GridActions.PrepareGridDataSourceForExport(dSource, options);

        } else {
            this.dataSource = kendo.data.DataSource.create(dSource);
        }
        var mpamt = Math.ceil(dSource.total() / this.dataSource.pageSize()) + 1;
        if (isNaN(mpamt)) mpamt = 0;
        this.options.pagesAmount = Math.min(this.options.pagesAmount >= 0 ? this.options.pagesAmount : mpamt, mpamt);
    },
    workbook: function (srcBook) {
        var self = this;
        var r = $.Deferred();
        var cpage = self.options.pageIndex, mpages = self.options.pagesAmount, spent = 0;
        mpages = Math.max(1, mpages);
        var workbook = srcBook ? srcBook : {};
        if (!!(!(workbook.sheets))) workbook.sheets = [];
        var ensureLast = function () {
            if (cpage >= mpages) {
                r.resolve(workbook, self.dataSource.view());
            } else {
                cpage = cpage + 1;
                if (spent > 600) r.resolve(workbook, self.dataSource.view());//more then 10min?=stop it
                else pnext();
            }
            spent = (self.options.message) ? self.options.message(cpage >= mpages ? mpages : cpage + 1, mpages, cpage) : 0;
        };
        var pnext = function () {
            self.dataSource.page(cpage);
            self.dataSource.fetch().then($.proxy(function () {
                if (!self.options.joinPages || workbook.sheets.length < 1) {
                    workbook.sheets.push({ columns: this._columns(), rows: this._rows(), freezePane: this._freezePane(), filter: this._filter(), name: "p" + String(cpage) });
                } else {
                    _.each(this._rows(), function (ri) {
                        if (ri.type == "data") workbook.sheets[0].rows.push(ri);
                    });
                }
                setTimeout(ensureLast, 1);
            }, self));
        };
        pnext();
        return r.promise();
    },
    _trimColumns: function (columns) {
        var that = this;
        return $.grep(columns, function (column) {
            var result = !!column.field;
            if (!result && column.columns) {
                result = that._trimColumns(column.columns).length > 0;
            }
            return result;
        });
    },
    _leafColumns: function (columns) {
        var result = [];
        for (var idx = 0; idx < columns.length; idx++) {
            if (!columns[idx].columns) {
                result.push(columns[idx]);
                continue;
            }
            result = result.concat(this._leafColumns(columns[idx].columns));
        }
        return result;
    },
    _prepareColumn: function (column) {
        if (!column.field) {
            return;
        }
        var value = function (dataItem) {
            return dataItem.get(column.field);
        };
        var values = null;
        if (column.values) {
            values = {};
            $.each(column.values, function () {
                values[this.value] = this.text;
            });
            value = function (dataItem) {
                return values[dataItem.get(column.field)];
            };
        }
        return $.extend({}, column, {
            value: value,
            values: values,
            groupHeaderTemplate: kendo.template(column.groupHeaderTemplate || '#= title #: #= value #'),
            groupFooterTemplate: column.groupFooterTemplate ? kendo.template(column.groupFooterTemplate) : null,
            footerTemplate: column.footerTemplate ? kendo.template(column.footerTemplate) : null
        });
    },
    _filter: function () {
        if (!this.options.filterable) {
            return null;
        }
        var depth = this._depth();
        return {
            from: depth,
            to: depth + this.columns.length - 1
        };
    },
    _dataRow: function (dataItem, level, depth) {
        if (this._hierarchical()) {
            level = this.dataSource.level(dataItem) + 1;
        }
        var cells = [];
        for (var li = 0; li < level; li++) {
            cells[li] = {
                background: '#dfdfdf',
                color: '#333'
            };
        }
        if (depth && dataItem.items) {
            var column = $.grep(this.allColumns, function (column) {
                return column.field == dataItem.field;
            })[0];
            var title = column && column.title ? column.title : dataItem.field;
            var template = column ? column.groupHeaderTemplate : null;
            var value = title + ': ' + dataItem.value;
            var group = $.extend({
                title: title,
                field: dataItem.field,
                value: column && column.values ? column.values[dataItem.value] : dataItem.value,
                aggregates: dataItem.aggregates,
                items: dataItem.items
            }, dataItem.aggregates[dataItem.field]);
            if (template) {
                value = template(group);
            }
            cells.push({
                value: value,
                background: '#dfdfdf',
                color: '#333',
                colSpan: this.columns.length + depth - level
            });
            var rows = this._dataRows(dataItem.items, level + 1);
            rows.unshift({
                type: 'group-header',
                cells: cells
            });
            return rows.concat(this._footer(dataItem));
        } else {
            var dataCells = [];
            for (var ci = 0; ci < this.columns.length; ci++) {
                dataCells[ci] = this._cell(dataItem, this.columns[ci]);
            }
            if (this._hierarchical()) {
                dataCells[0].colSpan = depth - level + 1;
            }
            return [{
                type: 'data',
                cells: cells.concat(dataCells)
            }];
        }
    },
    _dataRows: function (dataItems, level) {
        var depth = this._depth();
        var rows = [];
        for (var i = 0; i < dataItems.length; i++) {
            rows.push.apply(rows, this._dataRow(dataItems[i], level, depth));
        }
        return rows;
    },
    _footer: function (dataItem) {
        var rows = [];
        var footer = false;
        var cells = $.map(this.columns, $.proxy(function (column) {
            if (column.groupFooterTemplate) {
                var groupData = {
                    group: {
                        items: dataItem.items,
                        field: dataItem.field,
                        value: dataItem.value
                    }
                };
                footer = true;
                return {
                    background: '#dfdfdf',
                    color: '#333',
                    value: column.groupFooterTemplate($.extend({}, this.dataSource.aggregates(), dataItem.aggregates, dataItem.aggregates[column.field], groupData))
                };
            } else {
                return {
                    background: '#dfdfdf',
                    color: '#333'
                };
            }
        }, this));
        if (footer) {
            rows.push({
                type: 'group-footer',
                cells: $.map(new Array(this.dataSource.group().length), function () {
                    return {
                        background: '#dfdfdf',
                        color: '#333'
                    };
                }).concat(cells)
            });
        }
        return rows;
    },
    _isColumnVisible: function (column) {
        return this._visibleColumns([column]).length > 0 && (column.field || column.columns);
    },
    _visibleColumns: function (columns) {
        var that = this;
        return $.grep(columns, function (column) {
            var result = !column.hidden;
            if (result && column.columns) {
                result = that._visibleColumns(column.columns).length > 0;
            }
            return result;
        });
    },
    _headerRow: function (row, groups) {
        var headers = $.map(row.cells, function (cell) {
            return {
                background: '#7a7a7a',
                color: '#fff',
                value: cell.title,
                colSpan: cell.colSpan > 1 ? cell.colSpan : 1,
                rowSpan: row.rowSpan > 1 && !cell.colSpan ? row.rowSpan : 1
            };
        });
        if (this._hierarchical()) {
            headers[0].colSpan = this._depth() + 1;
        }
        return {
            type: 'header',
            cells: $.map(new Array(groups.length), function () {
                return {
                    background: '#7a7a7a',
                    color: '#fff'
                };
            }).concat(headers)
        };
    },
    _prependHeaderRows: function (rows) {
        var groups = this.dataSource.group();
        var headerRows = [{
            rowSpan: 1,
            cells: [],
            index: 0
        }];
        this._prepareHeaderRows(headerRows, this.options.columns);
        for (var idx = headerRows.length - 1; idx >= 0; idx--) {
            rows.unshift(this._headerRow(headerRows[idx], groups));
        }
    },
    _prepareHeaderRows: function (rows, columns, parentCell, parentRow) {
        var row = parentRow || rows[rows.length - 1];
        var childRow = rows[row.index + 1];
        var totalColSpan = 0;
        var column;
        var cell;
        for (var idx = 0; idx < columns.length; idx++) {
            column = columns[idx];
            if (this._isColumnVisible(column)) {
                cell = {
                    title: column.title || column.field,
                    colSpan: 0
                };
                row.cells.push(cell);
                if (column.columns && column.columns.length) {
                    if (!childRow) {
                        childRow = {
                            rowSpan: 0,
                            cells: [],
                            index: rows.length
                        };
                        rows.push(childRow);
                    }
                    cell.colSpan = this._trimColumns(this._visibleColumns(column.columns)).length;
                    this._prepareHeaderRows(rows, column.columns, cell, childRow);
                    totalColSpan += cell.colSpan - 1;
                    row.rowSpan = rows.length - row.index;
                }
            }
        }
        if (parentCell) {
            parentCell.colSpan += totalColSpan;
        }
    },
    _rows: function () {
        var groups = this.dataSource.group();
        var rows = this._dataRows(this.dataSource.view(), 0);
        if (this.columns.length) {
            this._prependHeaderRows(rows);
            var footer = false;
            var cells = $.map(this.columns, $.proxy(function (column) {
                if (column.footerTemplate) {
                    footer = true;
                    var aggregates = this.dataSource.aggregates();
                    return {
                        background: '#dfdfdf',
                        color: '#333',
                        value: column.footerTemplate($.extend({}, aggregates, aggregates[column.field]))
                    };
                } else {
                    return {
                        background: '#dfdfdf',
                        color: '#333'
                    };
                }
            }, this));
            if (footer) {
                rows.push({
                    type: 'footer',
                    cells: $.map(new Array(groups.length), function () {
                        return {
                            background: '#dfdfdf',
                            color: '#333'
                        };
                    }).concat(cells)
                });
            }
        }
        return rows;
    },
    _headerDepth: function (columns) {
        var result = 1;
        var max = 0;
        for (var idx = 0; idx < columns.length; idx++) {
            if (columns[idx].columns) {
                var temp = this._headerDepth(columns[idx].columns);
                if (temp > max) {
                    max = temp;
                }
            }
        }
        return result + max;
    },
    _freezePane: function () {
        var columns = this._visibleColumns(this.options.columns || []);
        var colSplit = this._visibleColumns(this._trimColumns(this._leafColumns($.grep(columns, function (column) {
            return column.locked;
        })))).length;
        return {
            rowSplit: this._headerDepth(columns),
            colSplit: colSplit ? colSplit + this.dataSource.group().length : 0
        };
    },
    _cell: function (dataItem, column) {
        return { value: column.value(dataItem) };
    },
    _hierarchical: function () {
        return this.options.hierarchy && this.dataSource.level;
    },
    _depth: function () {
        var dataSource = this.dataSource;
        var depth = 0;
        var view, i, level;
        if (this._hierarchical()) {
            view = dataSource.view();
            for (i = 0; i < view.length; i++) {
                level = dataSource.level(view[i]);
                if (level > depth) {
                    depth = level;
                }
            }
            depth++;
        } else {
            depth = dataSource.group().length;
        }
        return depth;
    },
    _columns: function () {
        var depth = this._depth();
        var columns = $.map(new Array(depth), function () {
            return { width: 20 };
        });
        return columns.concat($.map(this.columns, function (column) {
            return {
                width: parseInt(column.width, 10),
                autoWidth: column.width ? false : true
            };
        }));
    }
});
XPortal.pdfExporter = kendo.Class.extend({
    saveAsPDF: function (gridInfo, opts) {
        var self = this;
        var progress = new $.Deferred();
        var promise = progress.promise();
        var args = { promise: promise };
        if (gridInfo.kgrid.trigger('pdfExport', args)) return;
        var options = gridInfo.kgrid.options.pdf;
        options.multiPage = options.multiPage || options.allPages;

        self.drawPDF(gridInfo, opts, progress).then(function (root) {
            return kendo.drawing.exportPDF(root, options);
        }).done(function (dataURI) {
            kendo.saveAs({
                dataURI: dataURI,
                fileName: options.fileName,
                proxyURL: options.proxyURL,
                forceProxy: options.forceProxy,
                proxyTarget: options.proxyTarget
            });
            progress.resolve();
        }).fail(function (err) {
            progress.reject(err);
        });
        return promise;
    },
    drawPDF: function (gridInfo, opts, progress) {
        var self = this;
        var grid = gridInfo.kgrid;
        if (grid.options.pdf.paperSize && grid.options.pdf.paperSize != 'auto')
            return grid._drawPDF_autoPageBreak(progress);
        var result = new $.Deferred();
        var dataSource = grid.dataSource;
        var allPages = grid.options.pdf.allPages;
        var doc = new kendo.drawing.Group();
        var startingPage = dataSource.page();
        opts.Pages = [];
        function msg() {
            var cpage = dataSource.page() - 1;
            var totalPages = allPages ? dataSource.totalPages() : 1;
            opts.message(cpage >= totalPages ? totalPages : cpage, totalPages, cpage);
        };
        function resolve() {
            if (allPages && startingPage !== undefined) {
                dataSource.unbind('change', exportPage);
                dataSource.one('change', function () {
                    result.resolve(doc);
                });
                dataSource.page(startingPage);
            } else
                result.resolve(doc);
        }
        var exportStarted = 0;
        function exportPage() {
            exportStarted = 1;
            grid.toggleUnexportableColumns(grid.columns);
            msg();
            self.drawPDFShadow(gridInfo, opts, { width: (opts.exportListInstead ? gridInfo.klist.wrapper : gridInfo.kgrid.wrapper).width() }, { avoidLinks: grid.options.pdf.avoidLinks }).done(function (group) {
                msg();
                var pageNum = dataSource.page();
                var totalPages = allPages ? dataSource.totalPages() : 1;
                var args = { page: group, pageNumber: pageNum, progress: pageNum / totalPages, totalPages: totalPages };
                var pContent = self.getContentCopyOf(args);
                var existPage = self.getExistingPage(pContent, opts, pageNum, totalPages);
                var isGetNext = !existPage;
                if (!isGetNext) {
                    var etry = existPage.tries.find(x => x.pageNum == pageNum);
                    existPage.tries.push({ pageNum });
                    if (!etry) dataSource.read(); else isGetNext = true;
                }
                if (isGetNext) {
                    grid.toggleUnexportableColumns(grid.columns, true);
                    progress.notify(args);
                    doc.append(args.page);
                    if (pageNum < totalPages) dataSource.page(pageNum + 1);
                    else resolve();
                }
            }).fail(function (err) {
                result.reject(err);
            });
        }
        if (allPages) {
            dataSource.bind('change', exportPage);
            dataSource.page(1);
        } else exportPage();
        return result.promise();
    },
    drawPDFShadow: function (gridInfo, opts, settings, drawOptions) {
        settings = settings || {};
        var wrapper = opts.exportListInstead ? gridInfo.klist.wrapper : gridInfo.kgrid.wrapper;
        var shadow = $('<div class=\'k-pdf-export-shadow\'>');
        shadow.attr("id", "pdf_" + XPortal.Utils.guid().substring(0, 8));
        if (settings.width) shadow.css({ width: settings.width, overflow: 'visible' });
        wrapper.before(shadow);
        shadow.append(settings.content || wrapper.clone(true, true));
        var defer = $.Deferred();
        setTimeout(function () {
            var promise = kendo.drawing.drawDOM(shadow, drawOptions);
            promise.always(function () {
                //console.log("draw: " + gridInfo.kgrid.dataSource.page(), { data: shadow.find(".k-grid-content").find("tr").map((xi, x) => $(x).attr("data-uid")) });
                shadow.remove();
            }).then(function () {
                defer.resolve.apply(defer, arguments);
            }).fail(function () {
                defer.reject.apply(defer, arguments);
            }).progress(function () {
                defer.progress.apply(defer, arguments);
            });
        }, 15);
        return defer.promise();
    },
    getContentCopyOf: function (iobj) {
        var content = [];
        var objToProcess = [{ src: iobj, dst: {} }];
        while (objToProcess.length > 0) {
            var objx = objToProcess.pop();
            var obj = objx.src;
            var res = objx.dst;
            var keys = Object.keys(obj);
            for (var ki = 0; ki < keys.length; ki++) {
                var i = keys[ki];
                if (i && i.toLowerCase() != "parent" && i.indexOf("_") != 0) {
                    var ix = obj[i];
                    if (i == "content") content.push(ix);
                    if (_.isArray(ix)) {
                        res[i] = [];
                        for (var k = 0; k < ix.length; k++) {
                            var rik = {};
                            objToProcess.push({ src: ix[k], dst: rik });
                            res[i][k] = rik;
                        }
                    } else {
                        if (_.isObject(ix)) {
                            var rik = {};
                            objToProcess.push({ src: obj[i], dst: rik });
                            res[i] = rik;
                        } else
                            res[i] = obj[i];
                    }
                }
            }
        }
        return content;
    },
    getExistingPage: function (pContent, opts, pageNum, totalPages) {
        for (var i = 0; i < opts.Pages.length; i++) {
            var toCompare = opts.Pages[i];
            if (this.isSame(pContent, toCompare.content)) return toCompare;
        }
        opts.Pages.push({ content: pContent, pageNum, totalPages, tries: [] });
        return null;
    },
    isSame: function (pageA, pageB) {
        if (!pageA || !pageB) return false;
        if (pageA.length != pageB.length) return false;
        var r = [];
        for (var i = 0; i < pageA.length; i++)
            r[i] = { r: pageA[i] == pageB[i]/*, a: pageA[i], b: pageB[i]*/ };
        var diff = r.filter(x => !x.r).length;
        if ((diff * 100) / r.length < 15) return true;
        return false;
    }
});